import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.json.parse.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, vModelText as _vModelText, unref as _unref, Transition as _Transition, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "border-b border-slate-200"
};
const _hoisted_3 = {
  class: "flex space-x-8 px-6 overflow-x-auto"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  class: "ml-2 px-2 py-0.5 status-badge is-warning rounded-full text-xs"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
  class: "data-table-shell"
};
const _hoisted_10 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_11 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_12 = {
  class: "data-table-head"
};
const _hoisted_13 = {
  class: "data-table-th is-center"
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  colspan: "7"
};
const _hoisted_16 = {
  class: "data-table-empty"
};
const _hoisted_17 = {
  class: "text-sm text-slate-500"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  class: "data-table-td"
};
const _hoisted_20 = {
  class: "flex max-w-sm items-center gap-3"
};
const _hoisted_21 = {
  class: "h-4 w-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_22 = ["d"];
const _hoisted_23 = {
  class: "min-w-0 flex-1"
};
const _hoisted_24 = {
  class: "flex items-center gap-2"
};
const _hoisted_25 = {
  key: 0,
  class: "h-1.5 w-1.5 shrink-0 rounded-full bg-red-500"
};
const _hoisted_26 = ["title"];
const _hoisted_27 = {
  class: "data-table-cell-meta mt-1 flex items-center gap-2"
};
const _hoisted_28 = {
  key: 0,
  class: "shrink-0"
};
const _hoisted_29 = {
  key: 1,
  class: "shrink-0 font-medium text-slate-700 tabular-nums"
};
const _hoisted_30 = ["title"];
const _hoisted_31 = {
  class: "data-table-td text-center"
};
const _hoisted_32 = {
  class: "data-table-td"
};
const _hoisted_33 = {
  class: "flex items-center gap-2"
};
const _hoisted_34 = {
  class: "flex h-7 w-7 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary-100 text-xs font-medium text-primary-600"
};
const _hoisted_35 = ["src", "alt"];
const _hoisted_36 = {
  class: "text-slate-700"
};
const _hoisted_37 = {
  class: "data-table-td text-center"
};
const _hoisted_38 = {
  key: 1,
  class: "text-slate-300"
};
const _hoisted_39 = {
  class: "data-table-td text-center"
};
const _hoisted_40 = {
  class: "text-xs text-slate-600"
};
const _hoisted_41 = {
  key: 0,
  class: "data-table-cell-meta mt-0.5"
};
const _hoisted_42 = {
  class: "data-table-td text-center text-xs text-slate-600"
};
const _hoisted_43 = {
  key: 1,
  class: "text-slate-300"
};
const _hoisted_44 = {
  key: 2,
  class: "data-table-cell-meta mt-0.5"
};
const _hoisted_45 = {
  key: 0
};
const _hoisted_46 = {
  key: 1,
  class: "text-slate-300"
};
const _hoisted_47 = {
  key: 0
};
const _hoisted_48 = {
  key: 1,
  class: "text-slate-300"
};
const _hoisted_49 = {
  key: 2,
  class: "data-table-cell-meta mt-0.5"
};
const _hoisted_50 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_51 = ["onClick"];
const _hoisted_52 = ["onClick", "disabled"];
const _hoisted_53 = ["disabled", "onClick"];
const _hoisted_54 = ["onClick"];
const _hoisted_55 = ["onClick"];
const _hoisted_56 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_57 = {
  class: "p-6"
};
const _hoisted_58 = {
  class: "mb-4"
};
const _hoisted_59 = {
  class: "font-medium text-slate-900"
};
const _hoisted_60 = {
  class: "mb-4"
};
const _hoisted_61 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_62 = {
  class: "p-6 space-y-4"
};
const _hoisted_63 = {
  key: 0,
  class: "mt-1 text-xs text-slate-400"
};
const _hoisted_64 = {
  class: "grid grid-cols-2 gap-3"
};
const _hoisted_65 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_66 = ["disabled"];
const _hoisted_67 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_68 = {
  class: "text-sm text-slate-500 mt-0.5"
};
const _hoisted_69 = {
  class: "modal-stepper"
};
const _hoisted_70 = {
  class: "step-item"
};
const _hoisted_71 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_72 = {
  key: 1
};
const _hoisted_73 = {
  class: "flex-1 overflow-y-auto min-h-0"
};
const _hoisted_74 = {
  key: "step-1",
  class: "p-6"
};
const _hoisted_75 = {
  class: "relative mb-4"
};
const _hoisted_76 = {
  class: "grid grid-cols-12 gap-4 max-h-[58vh] overflow-hidden"
};
const _hoisted_77 = {
  class: "col-span-3 space-y-0.5 overflow-y-auto max-h-[58vh]"
};
const _hoisted_78 = {
  class: "category-item-count"
};
const _hoisted_79 = ["onClick"];
const _hoisted_80 = {
  class: "truncate"
};
const _hoisted_81 = {
  class: "category-item-count"
};
const _hoisted_82 = {
  class: "col-span-9 space-y-2 overflow-y-auto max-h-[58vh] pr-1"
};
const _hoisted_83 = {
  key: 0,
  class: "empty-state"
};
const _hoisted_84 = ["onClick"];
const _hoisted_85 = {
  class: "workflow-card-body"
};
const _hoisted_86 = {
  class: "flex items-center gap-2"
};
const _hoisted_87 = {
  class: "workflow-card-title"
};
const _hoisted_88 = {
  class: "px-1.5 py-0.5 bg-slate-100 text-slate-500 text-xs rounded font-medium"
};
const _hoisted_89 = {
  class: "workflow-card-desc"
};
const _hoisted_90 = {
  class: "workflow-card-meta"
};
const _hoisted_91 = {
  class: "flex items-center gap-2 flex-shrink-0"
};
const _hoisted_92 = {
  key: "step-2",
  class: "p-6"
};
const _hoisted_93 = {
  class: "workflow-info-bar"
};
const _hoisted_94 = {
  class: "text-sm font-semibold text-slate-900"
};
const _hoisted_95 = {
  class: "ml-2 px-1.5 py-0.5 bg-slate-100 text-slate-500 text-xs rounded font-medium"
};
const _hoisted_96 = {
  class: "text-xs text-slate-500 mt-0.5"
};
const _hoisted_97 = {
  class: "form-section"
};
const _hoisted_98 = {
  class: "grid grid-cols-3 gap-3"
};
const _hoisted_99 = {
  key: 0,
  class: "form-section"
};
const _hoisted_100 = {
  class: "grid grid-cols-2 gap-3"
};
const _hoisted_101 = {
  class: "flex items-center gap-1 text-slate-700"
};
const _hoisted_102 = {
  key: 0,
  class: "text-red-500 font-bold"
};
const _hoisted_103 = {
  key: 10,
  class: "w-full space-y-3"
};
const _hoisted_104 = {
  class: "flex items-center justify-between"
};
const _hoisted_105 = {
  class: "text-sm font-medium text-slate-700"
};
const _hoisted_106 = ["disabled", "title", "onClick"];
const _hoisted_107 = {
  class: "block text-xs font-medium text-slate-500 mb-1"
};
const _hoisted_108 = {
  key: 0,
  class: "text-red-500"
};
const _hoisted_109 = ["value"];
const _hoisted_110 = {
  class: "flex items-center gap-3"
};
const _hoisted_111 = {
  class: "text-xs text-slate-400"
};
const _hoisted_112 = {
  key: 0,
  class: "flex flex-wrap items-center justify-end gap-x-6 gap-y-1 rounded-lg bg-slate-50 border border-slate-200 px-3 py-2"
};
const _hoisted_113 = {
  key: 0,
  class: "text-sm"
};
const _hoisted_114 = {
  class: "text-slate-500"
};
const _hoisted_115 = {
  class: "font-medium text-slate-700"
};
const _hoisted_116 = {
  class: "form-section"
};
const _hoisted_117 = {
  class: "form-section"
};
const _hoisted_118 = {
  class: "form-section-header"
};
const _hoisted_119 = {
  class: "form-section-sub"
};
const _hoisted_120 = {
  class: "min-h-[100px]"
};
const _hoisted_121 = {
  key: 0,
  class: "space-y-2"
};
const _hoisted_122 = {
  key: 1,
  class: "space-y-0"
};
const _hoisted_123 = {
  class: "approval-node-card"
};
const _hoisted_124 = {
  class: "approval-node-body"
};
const _hoisted_125 = {
  class: "approval-node-name"
};
const _hoisted_126 = {
  key: 0,
  class: "approval-node-mode-tag"
};
const _hoisted_127 = {
  key: 0,
  class: "approval-node-approvers"
};
const _hoisted_128 = {
  class: "approval-node-avatar bg-primary-100 text-primary-600"
};
const _hoisted_129 = ["src"];
const _hoisted_130 = {
  key: 1
};
const _hoisted_131 = {
  class: "approval-node-approver-name"
};
const _hoisted_132 = {
  key: 0,
  class: "approval-node-approver-more"
};
const _hoisted_133 = {
  key: 1,
  class: "approval-node-empty"
};
const _hoisted_134 = {
  key: 2,
  class: "mt-3"
};
const _hoisted_135 = {
  class: "mt-1.5 text-xs text-slate-400"
};
const _hoisted_136 = {
  key: 0
};
const _hoisted_137 = {
  key: 1
};
const _hoisted_138 = {
  key: 2
};
const _hoisted_139 = {
  key: 3
};
const _hoisted_140 = {
  key: 0,
  class: "approval-node-connector"
};
const _hoisted_141 = {
  key: 2,
  class: "text-center py-8 bg-slate-50 rounded-xl text-sm text-slate-400"
};
const _hoisted_142 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex items-center justify-between bg-slate-50"
};
const _hoisted_143 = {
  class: "flex gap-3"
};
const _hoisted_144 = ["disabled"];
const _hoisted_145 = ["disabled"];
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import { getCategoriesWithTemplates, previewApprovalPath, getTemplateDetail, startApproval, getMyTasks, getMyInstances, getMyCcRecords, markCcRead, markAllCcRead, approveTask, cancelApproval, exportApprovalDocx, getTemplatePage, exportWorkflowStats } from '@/api/flow';
import ApprovalDetailModal from '@/components/ApprovalDetailModal.vue';
import FileUpload from '@/components/FileUpload.vue';
import { useApprovalToast } from '@/composables/useApprovalToast';
import { APPROVAL_ATTACHMENT_ACCEPT } from '@/utils/fileAccept';
import { downloadBlob, resolveBlobErrorMessage } from '@/utils/download';
import { validateStatsExportRange } from '@/utils/workflowStatsConfig';
import { getEffectiveMinRows, getEffectiveMaxRows, evaluateComputedExpression, roundMoney, sumDetailColumn } from '@/utils/workflowDetail';
import { useUserStore } from '@/stores/user';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'ApprovalCenter',
  setup(__props) {
    const wizardSteps = [{
      value: 1,
      label: '选择流程'
    }, {
      value: 2,
      label: '填写信息'
    }];
    const userStore = useUserStore();
    const activeTab = ref('pending');
    const selectedType = ref('');
    const selectedPriority = ref('');
    const loading = ref(false);
    const ccUnreadCount = ref(0);
    const markingAllCcRead = ref(false);
    const showDetailModal = ref(false);
    const showRejectModal = ref(false);
    const rejectReasonInput = ref(null);
    const selectedApproval = ref(null);
    const {
      syncHandledApproval
    } = useApprovalToast();
    const route = useRoute();

    // 分页数据
    const pagination = reactive({
      current: 1,
      size: 10,
      total: 0,
      totalPending: 0
    });

    // 发起审批相关状态
    const showInitiateModal = ref(false);
    const workflowSearch = ref('');
    const selectedCategoryId = ref(null);
    const currentStep = ref(1);
    const selectedWorkflow = ref(null);
    const workflowCategories = ref([]);
    const workflowTemplates = ref([]);
    const workflowLoading = ref(false);
    const workflowFileUploading = ref(0);

    // 审批路径数据
    const approvalPathData = ref(null);
    const approvalPathLoading = ref(false);
    const participantSelections = reactive({
      approvers: {},
      cc: {}
    });

    // 记录上一次表单数据中条件字段的值，用于判断是否需要刷新审批路径
    let lastFormDataValues = {};

    // 发起审批表单
    const initiateForm = reactive({
      title: '',
      priority: 'normal',
      amount: null,
      description: '',
      formData: {}
    });
    const approvalForm = reactive({
      comment: ''
    });
    const rejectForm = reactive({
      reason: ''
    });
    const tabs = computed(() => [{
      label: '待审批',
      value: 'pending',
      count: pagination.totalPending
    }, {
      label: '已审批',
      value: 'completed',
      count: 0
    }, {
      label: '我发起',
      value: 'initiated',
      count: 0
    }, {
      label: '抄送我',
      value: 'cc',
      count: ccUnreadCount.value
    }]);
    const approvals = ref([]);
    const routeReadonly = computed(() => route.query.readonly === 'true');
    const showApprovalActions = computed(() => {
      return activeTab.value === 'pending' && selectedApproval.value?.isTask && !routeReadonly.value;
    });
    function applyApprovalTabFromRouteQuery() {
      const routeTab = Array.isArray(route.query.tab) ? route.query.tab[0] : route.query.tab;
      const validTabs = ['pending', 'completed', 'initiated', 'cc'];
      if (!validTabs.includes(routeTab)) return false;
      if (activeTab.value === routeTab) return false;
      activeTab.value = routeTab;
      return true;
    }

    // 优先级映射
    const priorityMap = {
      0: {
        value: 'normal',
        text: '普通',
        class: 'status-badge is-neutral'
      },
      1: {
        value: 'high',
        text: '高优先级',
        class: 'status-badge is-warning'
      },
      2: {
        value: 'urgent',
        text: '紧急',
        class: 'status-badge is-danger'
      }
    };

    // 优先级字符串转数字
    const priorityValueToNum = {
      'normal': 0,
      'high': 1,
      'urgent': 2
    };

    // 状态徽章：统一使用共享 status-badge 语义变体 + 纯色状态点（与 WithdrawalReview 等页面一致）
    const approvalStatusStyles = {
      APPROVING: {
        badge: 'status-badge is-info',
        dot: 'bg-blue-500'
      },
      APPROVED: {
        badge: 'status-badge is-success',
        dot: 'bg-green-500'
      },
      REJECTED: {
        badge: 'status-badge is-danger',
        dot: 'bg-red-500'
      },
      CANCELLED: {
        badge: 'status-badge is-neutral',
        dot: 'bg-slate-400'
      },
      CANCELED: {
        badge: 'status-badge is-neutral',
        dot: 'bg-slate-400'
      },
      PENDING: {
        badge: 'status-badge is-warning',
        dot: 'bg-amber-500'
      },
      READ: {
        badge: 'status-badge is-neutral',
        dot: 'bg-slate-400'
      },
      COMPLETED: {
        badge: 'status-badge is-success',
        dot: 'bg-green-500'
      }
    };
    const defaultApprovalStatusStyle = {
      badge: 'status-badge is-neutral',
      dot: 'bg-slate-400'
    };
    const approvalStatusTextMap = {
      APPROVING: '审批中',
      APPROVED: '已通过',
      REJECTED: '已驳回',
      CANCELLED: '已取消',
      CANCELED: '已取消',
      PENDING: '待处理',
      READ: '已读',
      COMPLETED: '已处理'
    };
    function resolveApprovalStatus(approval) {
      if (!approval) return '';
      if (approval.isCcRecord && approval.ccStatus) {
        return String(approval.ccStatus).toUpperCase();
      }
      if (approval.status) {
        return String(approval.status).toUpperCase();
      }
      if (activeTab.value === 'pending') {
        return 'PENDING';
      }
      return '';
    }

    // 导出按钮显隐按实例状态 + 行 exportable 判断（与行状态徽章语义分离：抄送行徽章显示已读/未读，
    // 且标记已读后 approval.status 会被覆盖，故抄送行取稳定的 instanceStatus 字段；
    // exportable 由后端列表行 DTO 下发，模板未配置导出时不显示按钮）
    function resolveApprovalInstanceStatus(approval) {
      if (!approval) return '';
      const status = approval.isCcRecord ? approval.instanceStatus : approval.status;
      return status ? String(status).toUpperCase() : '';
    }
    function getApprovalStatusClass(approval) {
      const status = resolveApprovalStatus(approval);
      return (approvalStatusStyles[status] || defaultApprovalStatusStyle).badge;
    }
    function getApprovalStatusDotClass(approval) {
      const status = resolveApprovalStatus(approval);
      return (approvalStatusStyles[status] || defaultApprovalStatusStyle).dot;
    }
    function getApprovalStatusText(approval) {
      if (!approval) return '';
      const status = resolveApprovalStatus(approval);
      return approvalStatusTextMap[status] || approval.statusDesc || '';
    }
    function getApprovalModeBadgeText(node) {
      if (node?.nodeType !== 'APPROVAL') return '';
      if (!node?.approvers?.length || node?.approvers?.length <= 1) return '';
      if (node.approvalMode === 'ALL') return '会签';
      if (node.approvalMode === 'ANY') return '或签';
      return '';
    }

    // 加载待办任务
    async function loadMyTasks() {
      loading.value = true;
      try {
        const res = await getMyTasks({
          pageNum: pagination.current,
          pageSize: pagination.size,
          status: 'PENDING',
          ...buildListFilters()
        });
        const pageData = res || {};
        approvals.value = (pageData.records || []).map(task => normalizeApproval(task, true));
        pagination.total = pageData.total || 0;
        // 待审批 Tab 角标保持未筛选的总量语义，筛选时不被覆盖
        if (!selectedType.value && !selectedPriority.value) {
          pagination.totalPending = pageData.total || 0;
        }
      } catch (error) {
        console.error('加载待办任务失败:', error);
        ElMessage.error(error.message || '加载待办任务失败');
      } finally {
        loading.value = false;
      }
    }

    // 加载已审批任务
    async function loadCompletedTasks() {
      loading.value = true;
      try {
        const res = await getMyTasks({
          pageNum: pagination.current,
          pageSize: pagination.size,
          status: 'COMPLETED',
          ...buildListFilters()
        });
        const pageData = res || {};
        approvals.value = (pageData.records || []).map(instance => normalizeApproval(instance, false));
        pagination.total = pageData.total || 0;
      } catch (error) {
        console.error('加载已审批任务失败:', error);
        ElMessage.error(error.message || '加载失败');
      } finally {
        loading.value = false;
      }
    }

    // 加载我发起的审批
    async function loadMyInstances() {
      loading.value = true;
      try {
        const res = await getMyInstances({
          pageNum: pagination.current,
          pageSize: pagination.size,
          ...buildListFilters()
        });
        const pageData = res || {};
        approvals.value = (pageData.records || []).map(instance => normalizeApproval(instance, false));
        pagination.total = pageData.total || 0;
      } catch (error) {
        console.error('加载我发起的审批失败:', error);
        ElMessage.error(error.message || '加载失败');
      } finally {
        loading.value = false;
      }
    }

    // 加载抄送给我的审批
    async function loadMyCcRecords() {
      loading.value = true;
      try {
        const res = await getMyCcRecords({
          pageNum: pagination.current,
          pageSize: pagination.size,
          ...buildListFilters()
        });
        const records = Array.isArray(res) ? res : res?.records || [];
        approvals.value = records.map(record => normalizeCcRecord(record));
        pagination.total = Array.isArray(res) ? records.length : res?.total || records.length;
        await loadCcUnreadCount();
      } catch (error) {
        console.error('加载抄送记录失败:', error);
        ElMessage.error(error.message || '加载抄送记录失败');
      } finally {
        loading.value = false;
      }
    }
    async function loadCcUnreadCount() {
      try {
        const res = await getMyCcRecords({
          unreadOnly: true
        });
        const records = Array.isArray(res) ? res : res?.records || [];
        ccUnreadCount.value = Array.isArray(res) ? records.length : res?.total || records.length;
      } catch (error) {
        console.error('加载抄送未读数失败:', error);
      }
    }
    function normalizeApproval(source, isTask) {
      const formData = source.formData || {};
      const type = resolveApprovalType(source);
      return {
        id: source.id,
        instanceId: source.instanceId || source.id,
        instanceNo: source.instanceNo,
        title: source.title,
        applicant: source.applicantName,
        applicantAvatar: source.applicantAvatar,
        department: '',
        type,
        typeText: resolveApprovalTypeText(type, source),
        priority: priorityMap[source.priority]?.value || 'normal',
        priorityText: source.priorityDesc || priorityMap[source.priority]?.text || '普通',
        priorityClass: priorityMap[source.priority]?.class || 'status-badge is-neutral',
        amount: resolveAmount(source, formData),
        description: source.description,
        applyTime: source.createTime,
        waitTime: formatWaitTime(source.taskCreateTime || source.createTime),
        taskNodeName: source.nodeName,
        status: source.status,
        statusDesc: source.statusDesc,
        exportable: source.exportable,
        currentNodeName: source.currentNodeName,
        templateCode: source.templateCode,
        bizType: source.bizType,
        bizId: source.bizId || formData.applyId,
        taskId: source.taskId,
        taskCreateTime: source.taskCreateTime,
        actionType: source.actionType,
        actionTypeDesc: source.actionTypeDesc,
        actionRemark: source.actionRemark,
        completeTime: source.completeTime,
        currentApproverNames: source.currentApproverNames || [],
        formData,
        attachments: [],
        history: [],
        isTask
      };
    }
    function normalizeCcRecord(record) {
      const formData = record.formData || {};
      const type = resolveApprovalType(record);
      const applyTime = record.applyTime || record.createTime;
      return {
        id: `cc-${record.id}`,
        ccRecordId: record.id,
        instanceId: record.instanceId,
        instanceNo: record.instanceNo,
        title: record.title,
        applicant: record.applicantName,
        applicantAvatar: record.applicantAvatar,
        department: '',
        type,
        typeText: record.templateName,
        priority: priorityMap[record.priority]?.value || 'normal',
        priorityText: record.priorityDesc || priorityMap[record.priority]?.text || '普通',
        priorityClass: priorityMap[record.priority]?.class || 'status-badge is-neutral',
        amount: resolveAmount(record, formData),
        description: record.description,
        applyTime: record.applyTime || record.createTime,
        waitTime: formatWaitTime(applyTime),
        taskNodeName: record.nodeName,
        status: record.instanceStatus,
        statusDesc: record.status === 'READ' ? '已读' : '未读',
        currentNodeName: record.currentNodeName,
        templateCode: record.templateCode,
        bizType: record.bizType,
        bizId: record.bizId || formData.applyId,
        currentApproverNames: record.currentApproverNames || [],
        formData,
        attachments: [],
        history: [],
        isTask: false,
        isCcRecord: true,
        ccStatus: record.status,
        instanceStatus: record.instanceStatus,
        exportable: record.exportable
      };
    }
    function resolveApprovalType(source) {
      const formData = source.formData || {};
      if (source.bizType === 'wealth_fund_operation_approval' || source.templateCode === 'WEALTH_FUND_OPERATION_FLOW' || formData?.bizType === 'wealth_fund_operation_approval' || formData?.applyId) {
        return 'wealth';
      }
      if (source.bizType === 'customer_referrer_change_approval') return 'customer';
      if (source.bizType === 'order_amount_change_approval' || source.bizType === 'order_add_approval' || source.templateCode === 'ORDER_ADD_APPROVAL_FLOW') return 'order';
      if (source.bizType === 'refund' || source.templateCode === 'REFUND_FLOW') return 'refund';
      if (source.bizType === 'product_publish' || source.bizType === 'product_unpublish' || source.templateCode === 'PRODUCT_PUBLISH_FLOW' || source.templateCode === 'PRODUCT_UNPUBLISH_FLOW') return 'product';
      if (source.templateCode === 'PLAN_APPROVAL_FLOW') return 'proposal';
      return 'proposal';
    }
    function resolveApprovalTypeText(type, source) {
      if (type === 'wealth') return '财富资金审批';
      if (type === 'customer') return '客户审批';
      if (type === 'order') return '订单审批';
      if (type === 'refund') return '退款审批';
      if (type === 'product') return source.bizType === 'product_unpublish' ? '产品下架审批' : '产品上架审批';
      return source.templateName || '审批';
    }

    // 列表筛选参数（下推给后端，与服务端分页保持一致）
    function buildListFilters() {
      return {
        type: selectedType.value || undefined,
        priority: selectedPriority.value ? priorityValueToNum[selectedPriority.value] : undefined
      };
    }

    // 金额解析：优先后端标准化 amount，回退各业务表单字段
    function resolveAmount(source, formData) {
      const candidates = [source?.amount, formData?.amount, formData?.refundAmount, formData?.newAmount, formData?.totalAmount];
      for (const candidate of candidates) {
        if (candidate === null || candidate === undefined || candidate === '') continue;
        const value = Number(candidate);
        if (Number.isFinite(value)) return value;
      }
      return null;
    }

    // 金额展示格式：保留两位小数
    function formatAmount(amount) {
      return amount.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    // 我的操作徽章样式
    function getActionTypeClass(actionType) {
      if (actionType === 'AGREE') return 'is-success';
      if (actionType === 'REJECT') return 'is-danger';
      return 'is-neutral';
    }

    // 格式化等待时间
    function formatWaitTime(createTime) {
      if (!createTime) return '刚刚';
      const now = new Date();
      const create = new Date(createTime);
      const diff = Math.floor((now - create) / 1000 / 60); // 分钟

      if (diff < 1) return '刚刚';
      if (diff < 60) return `${diff}分钟`;
      if (diff < 1440) return `${Math.floor(diff / 60)}小时`;
      return `${Math.floor(diff / 1440)}天`;
    }

    // 打开详情弹窗
    const openDetailModal = async approval => {
      if (activeTab.value === 'cc') {
        await markCcRecordRead(approval);
      }
      selectedApproval.value = approval;
      approvalForm.comment = '';
      showDetailModal.value = true;
    };

    // 列表导出审批单据 Word：按钮显隐已按行 exportable 过滤，点击直接触发下载
    const exportingDocxInstanceId = ref(null);
    async function handleExportApprovalDocx(approval) {
      const instanceId = approval?.instanceId || approval?.id;
      if (!instanceId || exportingDocxInstanceId.value) return;
      exportingDocxInstanceId.value = instanceId;
      try {
        const {
          blob,
          fileName
        } = await exportApprovalDocx(instanceId);
        downloadBlob(blob, fileName);
        ElMessage.success('导出成功');
      } catch (error) {
        ElMessage.error(await resolveBlobErrorMessage(error));
      } finally {
        exportingDocxInstanceId.value = null;
      }
    }

    // 取消自己发起的审批（仅审批中可取消，后端会再次校验申请人身份和流程状态）
    const cancellingInstanceId = ref(null);
    async function handleCancelApproval(approval) {
      const instanceId = approval?.instanceId;
      if (!instanceId || cancellingInstanceId.value) return;
      try {
        await ElMessageBox.confirm(`确定取消审批「${approval.title || approval.instanceNo || instanceId}」吗？取消后流程将变为已取消状态。`, '取消审批确认', {
          confirmButtonText: '确认取消',
          cancelButtonText: '再想想',
          type: 'warning'
        });
        cancellingInstanceId.value = instanceId;
        await cancelApproval({
          instanceId,
          reason: '发起人主动取消'
        });
        ElMessage.success('取消成功');
        await loadMyInstances();
      } catch (error) {
        if (error === 'cancel' || error?.message === 'cancel') return;
        ElMessage.error(error.message || '取消失败');
      } finally {
        cancellingInstanceId.value = null;
      }
    }

    // 统计导出（spec §5.4 审批中心入口）：模板下拉仅展示已配置统计导出（statsExportable）的模板
    const showStatsExportModal = ref(false);
    const statsExporting = ref(false);
    const statsTemplatesLoading = ref(false);
    const statsTemplates = ref([]);
    const statsExportForm = reactive({
      templateCode: '',
      startDate: '',
      endDate: ''
    });
    const statsExportTemplates = computed(() => statsTemplates.value.filter(tpl => tpl.statsExportable === true));
    async function openStatsExportModal() {
      statsExportForm.templateCode = '';
      statsExportForm.startDate = '';
      statsExportForm.endDate = '';
      showStatsExportModal.value = true;
      statsTemplatesLoading.value = true;
      try {
        const data = await getTemplatePage({
          pageNum: 1,
          pageSize: 200
        });
        statsTemplates.value = data.records || [];
      } catch (error) {
        ElMessage.error(error.message || '获取流程模板失败');
      } finally {
        statsTemplatesLoading.value = false;
      }
    }
    function closeStatsExportModal() {
      if (statsExporting.value) return;
      showStatsExportModal.value = false;
    }
    async function handleStatsExport() {
      if (statsExporting.value) return;
      if (!statsExportForm.templateCode) {
        ElMessage.warning('请选择流程模板');
        return;
      }
      const rangeError = validateStatsExportRange(statsExportForm.startDate, statsExportForm.endDate);
      if (rangeError) {
        ElMessage.warning(rangeError);
        return;
      }
      statsExporting.value = true;
      try {
        const {
          blob,
          fileName
        } = await exportWorkflowStats({
          ...statsExportForm
        });
        downloadBlob(blob, fileName);
        ElMessage.success('导出成功');
        showStatsExportModal.value = false;
      } catch (error) {
        ElMessage.error(await resolveBlobErrorMessage(error));
      } finally {
        statsExporting.value = false;
      }
    }
    async function markCcRecordRead(approval) {
      if (!approval?.isCcRecord || approval.ccStatus === 'READ' || !approval.ccRecordId) return;
      try {
        await markCcRead(approval.ccRecordId);
        approval.ccStatus = 'READ';
        approval.status = 'READ';
        approval.statusDesc = '已读';
        if (ccUnreadCount.value > 0) {
          ccUnreadCount.value -= 1;
        }
      } catch (error) {
        console.error('标记抄送已读失败:', error);
      }
    }

    // 一键将未读抄送全部标记为已读
    async function handleMarkAllCcRead() {
      if (markingAllCcRead.value || ccUnreadCount.value <= 0) return;
      markingAllCcRead.value = true;
      try {
        const res = await markAllCcRead();
        const markedCount = typeof res === 'number' ? res : res?.data ?? 0;
        ElMessage.success(markedCount > 0 ? `已将 ${markedCount} 条抄送标记为已读` : '已将全部抄送标记为已读');
        await loadMyCcRecords();
      } catch (error) {
        console.error('一键标记抄送已读失败:', error);
        ElMessage.error(error.message || '一键已读失败');
      } finally {
        markingAllCcRead.value = false;
      }
    }
    async function openDetailFromRouteQuery() {
      if (route.query.openDetail !== 'true') return;
      const instanceId = route.query.id;
      if (!instanceId) return;
      const rawCcRecordId = Array.isArray(route.query.ccRecordId) ? route.query.ccRecordId[0] : route.query.ccRecordId;
      const ccRecordId = rawCcRecordId ? String(rawCcRecordId) : '';
      if (activeTab.value === 'cc' && ccRecordId) {
        try {
          await markCcRead(ccRecordId);
          await loadMyCcRecords();
        } catch (error) {
          console.error('标记路由抄送已读失败:', error);
        }
      }
      selectedApproval.value = {
        id: Number(instanceId),
        instanceId: Number(instanceId),
        type: selectedType.value || 'proposal',
        priority: 'normal',
        isTask: !routeReadonly.value
      };
      approvalForm.comment = '';
      showDetailModal.value = true;
    }

    // 通过审批
    const handleApprove = async ({
      comment
    }) => {
      try {
        await approveTask({
          instanceId: selectedApproval.value.instanceId || selectedApproval.value.id,
          actionType: 'AGREE',
          remark: comment
        });
        ElMessage.success('审批通过');
        syncHandledApproval(selectedApproval.value.id);
        showDetailModal.value = false;
        loadApprovalsByTab();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    };

    // 驳回审批
    const handleReject = () => {
      rejectForm.reason = '';
      showRejectModal.value = true;
      showDetailModal.value = false;
    };
    async function loadApprovalsByTab() {
      if (activeTab.value === 'pending') {
        await loadMyTasks();
      } else if (activeTab.value === 'initiated') {
        await loadMyInstances();
      } else if (activeTab.value === 'cc') {
        await loadMyCcRecords();
      } else {
        // 已审批
        await loadCompletedTasks();
      }
    }
    function handleSearch() {
      pagination.current = 1;
      loadApprovalsByTab();
    }
    function handleReset() {
      selectedType.value = '';
      selectedPriority.value = '';
      pagination.current = 1;
      loadApprovalsByTab();
    }
    function handleRefresh() {
      loadCcUnreadCount();
      loadApprovalsByTab();
    }

    // 弹窗打开时锁定body滚动
    watch(showInitiateModal, val => {
      document.body.style.overflow = val ? 'hidden' : '';
    });

    // 切换tab时重新加载
    watch(activeTab, () => {
      pagination.current = 1;
      loadApprovalsByTab();
    });

    // 分页切换
    function handlePageChange(page) {
      pagination.current = page;
      loadApprovalsByTab();
    }
    function handlePageSizeChange(size) {
      pagination.size = size;
      pagination.current = 1;
      loadApprovalsByTab();
    }

    // 初始化加载
    onMounted(() => {
      loadCcUnreadCount();
      const tabChanged = applyApprovalTabFromRouteQuery();
      if (!tabChanged) {
        loadApprovalsByTab();
      }
      openDetailFromRouteQuery();
    });
    watch(() => route.query, () => {
      applyApprovalTabFromRouteQuery();
      openDetailFromRouteQuery();
    });
    const emptyStateText = computed(() => {
      if (activeTab.value === 'pending') return '暂无待审批事项';
      if (activeTab.value === 'initiated') return '暂无我发起的审批';
      if (activeTab.value === 'cc') return '暂无抄送给我的审批';
      return '暂无已审批记录';
    });
    const canSubmitInitiate = computed(() => {
      if (!initiateForm.title || workflowFileUploading.value > 0) return false;
      if (approvalPathLoading.value || !approvalPathData.value) return false;
      if (hasMissingRequiredParticipantSelections()) return false;
      return true;
    });

    // 发起审批计算属性
    const filteredWorkflows = computed(() => {
      let workflows = workflowTemplates.value.filter(w => w.status === 1); // 只显示已启用的流程

      if (workflowSearch.value) {
        const search = workflowSearch.value.toLowerCase();
        workflows = workflows.filter(w => w.templateName.toLowerCase().includes(search) || w.description?.toLowerCase().includes(search));
      }
      if (selectedCategoryId.value) {
        workflows = workflows.filter(w => w.categoryCode);
      }
      return workflows;
    });
    const workflowFormFields = computed(() => {
      if (!selectedWorkflow.value?.formSchema) return [];
      try {
        const formSchema = typeof selectedWorkflow.value.formSchema === 'string' ? JSON.parse(selectedWorkflow.value.formSchema) : selectedWorkflow.value.formSchema;
        return formSchema?.fields || [];
      } catch {
        return [];
      }
    });
    function getWorkflowNumberMin(field) {
      return normalizeWorkflowNumberBound(field?.min);
    }
    function getWorkflowNumberMax(field) {
      return normalizeWorkflowNumberBound(field?.max);
    }
    function normalizeWorkflowNumberBound(value) {
      if (value === null || value === undefined || value === '') return undefined;
      const numberValue = Number(value);
      return Number.isFinite(numberValue) ? numberValue : undefined;
    }

    // 根据条件判断实际展示的流程路径（跳过条件节点，类似钉钉设计）
    const displayedApprovalPath = computed(() => {
      if (!approvalPathData.value) return null;
      const pathNodes = approvalPathData.value.pathNodes || [];
      const conditionBranches = approvalPathData.value.conditionBranches || [];
      const formData = initiateForm.formData;

      // 构建节点映射
      const nodeMap = new Map();
      pathNodes.forEach(node => {
        nodeMap.set(node.nodeId, node);
      });

      // 条件判断函数
      function evaluateCondition(fieldValue, operator, branchValue) {
        // 如果字段值为空，默认不匹配
        if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
          return false;
        }

        // 转换类型进行比较
        const fv = fieldValue;
        const bv = branchValue;
        switch (operator) {
          case 'EQ':
            return String(fv) === String(bv);
          case 'NEQ':
            return String(fv) !== String(bv);
          case 'GT':
            return Number(fv) > Number(bv);
          case 'GTE':
            return Number(fv) >= Number(bv);
          case 'LT':
            return Number(fv) < Number(bv);
          case 'LTE':
            return Number(fv) <= Number(bv);
          case 'IN':
            if (Array.isArray(bv)) {
              return bv.includes(fv);
            }
            return String(bv).split(',').map(s => s.trim()).includes(String(fv));
          case 'CONTAINS':
            return String(fv).includes(String(bv));
          default:
            return false;
        }
      }

      // 构建实际展示的审批节点列表
      const displayedNodes = [];
      if (conditionBranches.length > 0) {
        // 有条件分支时，根据表单数据判断走哪个分支
        const condition = conditionBranches[0];
        let targetNodeId = null;
        if (condition?.branches) {
          // 遍历条件分支，查找匹配的分支
          for (const branch of condition.branches) {
            const fieldValue = formData[branch.field];
            if (evaluateCondition(fieldValue, branch.operator, branch.value)) {
              targetNodeId = branch.targetNodeId;
              break;
            }
          }
          // 如果没有匹配的分支，默认走第一个分支
          if (!targetNodeId && condition.branches.length > 0) {
            targetNodeId = condition.branches[0].targetNodeId;
          }
        }

        // 按照 nextNodeId 遍历
        let currentNodeId = targetNodeId;
        let loopCount = 0;
        while (currentNodeId && loopCount < 20) {
          const node = nodeMap.get(currentNodeId);
          if (!node) {
            break;
          }

          // 只添加 APPROVAL 和 CC 类型的节点
          if (node.nodeType === 'APPROVAL' || node.nodeType === 'CC') {
            displayedNodes.push(node);
          }

          // 继续按 nextNodeId 遍历
          currentNodeId = node.nextNodeId;
          loopCount++;
        }
      } else {
        // 没有条件分支时，按照 nextNodeId 展示所有审批节点
        // 找到起始节点（第一个审批节点）
        const startNode = pathNodes.find(n => n.nodeType === 'APPROVAL' || n.nodeType === 'CC');
        let currentNodeId = startNode?.nodeId;
        while (currentNodeId) {
          const node = nodeMap.get(currentNodeId);
          if (!node) break;

          // 只添加 APPROVAL 和 CC 类型的节点
          if (node.nodeType === 'APPROVAL' || node.nodeType === 'CC') {
            displayedNodes.push(node);
          }

          // 继续按 nextNodeId 遍历
          currentNodeId = node.nextNodeId;
        }
      }
      return {
        ...approvalPathData.value,
        displayedNodes
      };
    });

    // 发起审批方法
    async function loadWorkflowData() {
      workflowLoading.value = true;
      try {
        const res = await getCategoriesWithTemplates();
        const data = res.data || res || [];

        // 转换为扁平化的分类和模板列表
        workflowCategories.value = data.map(item => ({
          id: item.categoryId,
          categoryCode: item.categoryCode,
          categoryName: item.categoryName
        }));

        // 收集所有模板
        const templates = [];
        data.forEach(item => {
          if (item.templates && item.templates.length > 0) {
            item.templates.forEach(t => {
              templates.push({
                id: t.id,
                templateCode: t.templateCode,
                templateName: t.templateName,
                description: t.description,
                version: t.version,
                categoryId: item.categoryId,
                categoryCode: item.categoryCode,
                categoryName: item.categoryName,
                status: 1 // 新接口返回的模板都是启用的
              });
            });
          }
        });
        workflowTemplates.value = templates;
      } catch (error) {
        console.error('加载流程数据失败:', error);
        ElMessage.error(error.message || '加载流程数据失败');
      } finally {
        workflowLoading.value = false;
      }
    }
    function openInitiateModal() {
      showInitiateModal.value = true;
      currentStep.value = 1;
      selectedWorkflow.value = null;
      selectedCategoryId.value = null;
      workflowSearch.value = '';
      resetInitiateForm();
      loadWorkflowData();
    }
    function closeInitiateModal() {
      showInitiateModal.value = false;
      selectedWorkflow.value = null;
      approvalPathData.value = null;
      clearParticipantSelections();
    }
    function goBack() {
      currentStep.value = 1;
    }
    function resetInitiateForm() {
      initiateForm.title = '';
      initiateForm.priority = 'normal';
      initiateForm.amount = null;
      initiateForm.description = '';
      initiateForm.formData = {};
      initiateForm.attachments = [];
      approvalPathData.value = null;
      clearParticipantSelections();
    }
    function clearParticipantSelections() {
      Object.keys(participantSelections.approvers).forEach(key => delete participantSelections.approvers[key]);
      Object.keys(participantSelections.cc).forEach(key => delete participantSelections.cc[key]);
    }
    const currentUser = computed(() => userStore.userInfo || {});

    // 当节点不允许选发起人时，从可选列表中排除当前用户
    function approverExcludeIdsForNode(node) {
      if (node?.allowApplicant === false && currentUser.value?.id) {
        return [currentUser.value.id];
      }
      return [];
    }
    function currentSelectionNodeIds() {
      const nodes = displayedApprovalPath.value?.displayedNodes || approvalPathData.value?.pathNodes || [];
      return new Set(nodes.filter(node => node.requiresSelection).map(node => node.nodeId));
    }
    function syncSelectionsWithDisplayedPath() {
      const validNodeIds = currentSelectionNodeIds();
      Object.keys(participantSelections.approvers).forEach(nodeId => {
        if (!validNodeIds.has(nodeId)) delete participantSelections.approvers[nodeId];
      });
      Object.keys(participantSelections.cc).forEach(nodeId => {
        if (!validNodeIds.has(nodeId)) delete participantSelections.cc[nodeId];
      });
    }
    function selectedUsersForNode(node) {
      return node.selectionType === 'CC' ? participantSelections.cc[node.nodeId] || [] : participantSelections.approvers[node.nodeId] || [];
    }
    function setSelectedUsersForNode(node, value) {
      const ids = Array.isArray(value) ? value : [];
      if (node.selectionType === 'CC') {
        participantSelections.cc[node.nodeId] = ids;
      } else {
        participantSelections.approvers[node.nodeId] = ids;
      }
      loadApprovalPath(true);
    }
    function getWorkflowAttachments(field) {
      const value = initiateForm.formData[field.key];
      return Array.isArray(value) ? value : [];
    }
    function onWorkflowUploadingChange(uploading) {
      if (uploading) {
        workflowFileUploading.value += 1;
      } else {
        workflowFileUploading.value = Math.max(0, workflowFileUploading.value - 1);
      }
    }

    // 明细表：添加一行（达到 maxRows 时模板侧隐藏入口，这里兜底；maxRows 空值=不限）
    function addDetailRow(field) {
      const rows = initiateForm.formData[field.key];
      if (!Array.isArray(rows)) {
        initiateForm.formData[field.key] = [createDetailRow(field)];
        return;
      }
      const maxRows = getEffectiveMaxRows(field);
      if (maxRows !== null && rows.length >= maxRows) return;
      rows.push(createDetailRow(field));
    }

    // 明细表：删除一行（行数等于有效最小行数时禁删）
    function removeDetailRow(field, index) {
      const rows = initiateForm.formData[field.key];
      if (!Array.isArray(rows) || rows.length <= getEffectiveMinRows(field)) return;
      rows.splice(index, 1);
    }
    function canRemoveDetailRow(field) {
      const rows = initiateForm.formData[field.key];
      return Array.isArray(rows) && rows.length > getEffectiveMinRows(field);
    }
    function canAddDetailRow(field) {
      const maxRows = getEffectiveMaxRows(field);
      if (maxRows === null) return true;
      const rows = initiateForm.formData[field.key];
      return !Array.isArray(rows) || rows.length < maxRows;
    }

    // 查找某列对应的合计配置
    function getDetailSummary(field, columnKey) {
      return (field.summary || []).find(s => s.column === columnKey) || null;
    }
    function formatDetailNumber(value, digits) {
      const num = Number(value);
      if (!Number.isFinite(num)) return '0';
      return Number.isInteger(digits) ? num.toLocaleString('zh-CN', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }) : num.toLocaleString();
    }

    // 实时重算：computed 列只读重算 + summary 合计写入 formData[targetKey]
    function recomputeDetailField(field) {
      // 本函数在 deep watch 回调中写回被监听源，收敛依赖 Vue hasChanged 同值去重（最多两轮），勿改为无条件触发副作用
      const rows = initiateForm.formData[field.key];
      if (!Array.isArray(rows)) return;
      const computedChildren = (field.children || []).filter(c => c.computed);
      rows.forEach(row => {
        computedChildren.forEach(child => {
          try {
            const value = evaluateComputedExpression(child.computed, row);
            row[child.key] = child.type === 'MONEY' ? roundMoney(value) : value;
          } catch {
            row[child.key] = null;
          }
        });
      });
      (field.summary || []).forEach(sum => {
        if (!sum.targetKey) return;
        const column = (field.children || []).find(c => c.key === sum.column);
        const total = sumDetailColumn(rows, sum.column);
        initiateForm.formData[sum.targetKey] = column?.type === 'MONEY' ? roundMoney(total) : total;
      });
    }
    function recomputeAllDetails() {
      workflowFormFields.value.filter(field => field.type === 'DETAIL').forEach(recomputeDetailField);
    }

    // 附件对象统一为提交结构（顶层 FILE 与 DETAIL 行内 FILE 共用）
    function normalizeWorkflowFileList(files) {
      return (Array.isArray(files) ? files : []).map(file => ({
        name: file.name,
        fileName: file.fileName || file.name,
        originalName: file.originalName || file.name,
        fileKey: file.fileKey,
        bucket: file.bucket || 'private',
        size: file.size,
        fileSize: file.fileSize || file.size,
        contentType: file.contentType
      }));
    }
    function buildSubmitFormData() {
      const formData = {
        ...initiateForm.formData
      };
      workflowFormFields.value.filter(field => field.type === 'FILE').forEach(field => {
        formData[field.key] = normalizeWorkflowFileList(getWorkflowAttachments(field));
      });
      // DETAIL：逐行规范化 FILE 子字段，行对象做浅拷贝避免直接改表单状态
      workflowFormFields.value.filter(field => field.type === 'DETAIL').forEach(field => {
        const fileChildren = (field.children || []).filter(c => c.type === 'FILE');
        if (!fileChildren.length) return;
        const rows = Array.isArray(formData[field.key]) ? formData[field.key] : [];
        formData[field.key] = rows.map(row => {
          const nextRow = {
            ...row
          };
          fileChildren.forEach(child => {
            nextRow[child.key] = normalizeWorkflowFileList(nextRow[child.key]);
          });
          return nextRow;
        });
      });
      return formData;
    }
    function validateParticipantSelections() {
      const pathNodes = displayedApprovalPath.value?.displayedNodes || approvalPathData.value?.pathNodes || [];
      for (const node of pathNodes) {
        if (!node.requiresSelection) continue;
        const selected = selectedUsersForNode(node);
        const min = node.selectionRequired ? node.minSelect ?? 1 : 0;
        if (node.selectionRequired && selected.length < min) {
          ElMessage.warning(`请选择${node.nodeName}的${node.selectionType === 'CC' ? '抄送人' : '审批人'}`);
          return false;
        }
        if (node.maxSelect && selected.length > node.maxSelect) {
          ElMessage.warning(`${node.nodeName}最多选择${node.maxSelect}人`);
          return false;
        }
      }
      return true;
    }
    function hasMissingRequiredParticipantSelections() {
      const pathNodes = displayedApprovalPath.value?.displayedNodes || approvalPathData.value?.pathNodes || [];
      for (const node of pathNodes) {
        if (!node.requiresSelection) continue;
        const selected = selectedUsersForNode(node);
        const min = node.selectionRequired ? node.minSelect ?? 1 : 0;
        if (node.selectionRequired && selected.length < min) {
          return true;
        }
      }
      return false;
    }
    function getCategoryWorkflowCount(categoryId) {
      return filteredWorkflows.value.filter(w => {
        const category = workflowCategories.value.find(c => c.id === categoryId);
        return category && w.categoryCode === category.categoryCode;
      }).length;
    }
    function getWorkflowFormInitialValue(field) {
      if (field.type === 'FILE' || field.type === 'CHECKBOX') {
        return [];
      }
      return null;
    }
    function normalizeWorkflowFormValue(field, value) {
      if (field.type === 'FILE' || field.type === 'CHECKBOX') {
        return Array.isArray(value) ? value : [];
      }
      return value;
    }
    function initializeWorkflowFormData(fields, {
      preserveExisting = false
    } = {}) {
      const previousFormData = {
        ...initiateForm.formData
      };
      const nextFormData = {};
      fields.forEach(field => {
        // 明细表：按有效最小行数预建行；targetKey 预初始化为 0（spec 5.3）
        if (field.type === 'DETAIL') {
          if (preserveExisting && Array.isArray(previousFormData[field.key])) {
            nextFormData[field.key] = previousFormData[field.key];
          } else {
            const rows = [];
            for (let i = 0; i < getEffectiveMinRows(field); i += 1) {
              rows.push(createDetailRow(field));
            }
            nextFormData[field.key] = rows;
          }
          const summaries = field.summary || [];
          summaries.forEach(sum => {
            if (sum.targetKey && nextFormData[sum.targetKey] === undefined) {
              nextFormData[sum.targetKey] = 0;
            }
          });
          return;
        }
        if (preserveExisting && Object.prototype.hasOwnProperty.call(previousFormData, field.key)) {
          nextFormData[field.key] = normalizeWorkflowFormValue(field, previousFormData[field.key]);
          return;
        }
        nextFormData[field.key] = getWorkflowFormInitialValue(field);
      });
      initiateForm.formData = nextFormData;
    }

    // 创建明细表空行（初值规则同顶层字段：FILE/CHECKBOX 为 []，其余为 null）
    function createDetailRow(field) {
      const row = {};
      (field.children || []).forEach(child => {
        row[child.key] = getWorkflowFormInitialValue(child);
      });
      return row;
    }
    async function selectWorkflow(workflow) {
      try {
        const sameWorkflowSelected = selectedWorkflow.value?.id === workflow.id;
        if (!sameWorkflowSelected) {
          clearParticipantSelections();
          approvalPathData.value = null;
        }
        // 先根据ID获取完整的流程详情
        const res = await getTemplateDetail(workflow.id);
        const detailData = res.data || res;

        // 更新选中的工作流，包含完整的formSchema和其他详情
        selectedWorkflow.value = {
          ...workflow,
          formSchema: detailData.formSchema,
          processNodes: detailData.processNodes,
          description: detailData.description || workflow.description
        };
        currentStep.value = 2;

        // 初始化表单数据
        initializeWorkflowFormData(workflowFormFields.value, {
          preserveExisting: sameWorkflowSelected
        });

        // 重置审批路径缓存
        if (!sameWorkflowSelected) {
          lastFormDataValues = {};
        }

        // 加载审批路径
        loadApprovalPath();
      } catch (error) {
        console.error('加载流程详情失败:', error);
        ElMessage.error(error.message || '加载流程详情失败');
      }
    }

    // 加载审批路径
    async function loadApprovalPath(forceRefresh = false) {
      if (!selectedWorkflow.value) return false;

      // 如果不是强制刷新，检查条件是否真的会影响审批路径
      if (!forceRefresh && approvalPathData.value) {
        const conditionBranches = approvalPathData.value.conditionBranches || [];

        // 如果没有条件分支，不需要刷新
        if (conditionBranches.length === 0) {
          return true;
        }

        // 获取条件分支的边界值
        const branchThresholds = conditionBranches[0]?.branches?.filter(b => b.operator === 'GTE' || b.operator === 'GT' || b.operator === 'LTE' || b.operator === 'LT' || b.operator === 'EQ').map(b => ({
          field: b.field,
          value: Number(b.value),
          operator: b.operator
        })) || [];

        // 如果有条件分支，检查当前值是否跨越了边界
        let needsRefresh = false;
        for (const threshold of branchThresholds) {
          const currentValue = Number(initiateForm.formData[threshold.field] ?? 0);
          const lastValue = Number(getLastFormDataValue(threshold.field) ?? 0);

          // 检查是否跨越了边界
          if (threshold.operator === 'GTE') {
            if (lastValue < threshold.value && currentValue >= threshold.value || lastValue >= threshold.value && currentValue < threshold.value) {
              needsRefresh = true;
              break;
            }
          } else if (threshold.operator === 'GT') {
            if (lastValue <= threshold.value && currentValue > threshold.value || lastValue > threshold.value && currentValue <= threshold.value) {
              needsRefresh = true;
              break;
            }
          } else if (threshold.operator === 'LTE') {
            if (lastValue > threshold.value && currentValue <= threshold.value || lastValue <= threshold.value && currentValue > threshold.value) {
              needsRefresh = true;
              break;
            }
          } else if (threshold.operator === 'LT') {
            if (lastValue >= threshold.value && currentValue < threshold.value || lastValue < threshold.value && currentValue >= threshold.value) {
              needsRefresh = true;
              break;
            }
          } else if (threshold.operator === 'EQ') {
            if (lastValue !== currentValue) {
              needsRefresh = true;
              break;
            }
          }
        }

        // 更新记录的值
        updateLastFormDataValues();

        // 如果不需要刷新，直接返回
        if (!needsRefresh) {
          return true;
        }
      }

      // 记录当前值用于下次比较
      updateLastFormDataValues();
      approvalPathLoading.value = true;
      try {
        const res = await previewApprovalPath(selectedWorkflow.value.id, {
          formData: initiateForm.formData,
          selectedApproverUserIds: participantSelections.approvers,
          selectedCcUserIds: participantSelections.cc
        });
        approvalPathData.value = res.data || res;
        syncSelectionsWithDisplayedPath();
        return true;
      } catch (error) {
        console.error('加载审批路径失败:', error);
        approvalPathData.value = null;
        ElMessage.error(error.message || '加载审批路径失败');
        return false;
      } finally {
        approvalPathLoading.value = false;
      }
    }

    // 更新上一次表单数据中条件字段的值
    lastFormDataValues = {};
    function updateLastFormDataValues() {
      const conditionFields = workflowFormFields.value.filter(f => f.type === 'NUMBER' || f.type === 'MONEY' || f.type === 'SELECT');
      conditionFields.forEach(f => {
        lastFormDataValues[f.key] = initiateForm.formData[f.key];
      });
      // DETAIL 合计值（targetKey）同样参与条件分支边界比较
      workflowFormFields.value.filter(f => f.type === 'DETAIL').forEach(f => (f.summary || []).forEach(sum => {
        if (sum.targetKey) {
          lastFormDataValues[sum.targetKey] = initiateForm.formData[sum.targetKey];
        }
      }));
    }
    function getLastFormDataValue(key) {
      return lastFormDataValues[key];
    }
    function isWorkflowFieldEmpty(field, value) {
      if (field.type === 'FILE' || field.type === 'CHECKBOX') {
        return !Array.isArray(value) || value.length === 0;
      }
      // 空白字符串视为空，对齐后端 String.isBlank()
      if (typeof value === 'string') {
        return value.trim() === '';
      }
      return value === undefined || value === null;
    }

    // EMAIL/PHONE 内置格式：与后端 FormDataValidator 一致（非空即校验，与模板 validation 无关）
    const WORKFLOW_EMAIL_PATTERN = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/;
    const WORKFLOW_PHONE_PATTERN = /^1[3-9]\d{9}$/;

    // 字段级规则集：与后端对齐（spec 4.2）；prefix 为空表示顶层字段，否则为「明细表名第 N 行：」
    function validateWorkflowFieldValue(field, value, prefix) {
      // computed 列由前端实时重算、后端重算比对，不做录入校验
      if (field.computed) return '';
      if (isWorkflowFieldEmpty(field, value)) {
        return field.required ? `${prefix}请填写${field.label}` : '';
      }
      if (['NUMBER', 'MONEY'].includes(field.type)) {
        const num = Number(value);
        if (Number.isFinite(num)) {
          const min = normalizeWorkflowNumberBound(field.min);
          const max = normalizeWorkflowNumberBound(field.max);
          if (min !== undefined && num < min) return `${prefix}${field.label}不能小于 ${min}`;
          if (max !== undefined && num > max) return `${prefix}${field.label}不能大于 ${max}`;
        }
      }
      if (field.type === 'EMAIL' && !WORKFLOW_EMAIL_PATTERN.test(String(value))) {
        return `${prefix}${field.label}格式不正确`;
      }
      if (field.type === 'PHONE' && !WORKFLOW_PHONE_PATTERN.test(String(value))) {
        return `${prefix}${field.label}格式不正确`;
      }
      if (['TEXT', 'TEXTAREA', 'EMAIL', 'PHONE', 'URL'].includes(field.type)) {
        const text = String(value);
        if (field.maxLength && text.length > field.maxLength) {
          return `${prefix}${field.label}长度不能超过 ${field.maxLength} 字`;
        }
        if (field.validation) {
          try {
            // 后端用 Matcher.matches() 全串匹配，这里包 ^(?:...)$ 对齐
            if (!new RegExp(`^(?:${field.validation})$`).test(text)) {
              return `${prefix}${field.validationMessage || `${field.label}格式不正确`}`;
            }
          } catch {
            // 非法正则跳过，合法性由设计器保存前校验保证
          }
        }
      }
      return '';
    }

    // 行内校验：错误定位到 1-based 行号（spec 第 2 节"行号统一 1-based"）
    function validateDetailRows(field, rows) {
      for (let i = 0; i < rows.length; i += 1) {
        const prefix = `${field.label}第 ${i + 1} 行：`;
        for (const child of field.children || []) {
          // computed 列求值失败（如除零）时值为 null，后端重算同样失败必拒，提交前拦截
          if (child.computed && (rows[i]?.[child.key] === null || rows[i]?.[child.key] === undefined)) {
            return `${prefix}${child.label}计算结果无效，请检查输入`;
          }
          const error = validateWorkflowFieldValue(child, rows[i]?.[child.key], prefix);
          if (error) return error;
        }
      }
      return '';
    }

    // 提交前整体校验：顶层字段 + DETAIL 行数区间 + 行内规则集
    function validateWorkflowForm() {
      const formFields = workflowFormFields.value;
      for (const field of formFields) {
        if (field.type === 'DETAIL') {
          const rows = Array.isArray(initiateForm.formData[field.key]) ? initiateForm.formData[field.key] : [];
          const minRows = getEffectiveMinRows(field);
          if (rows.length < minRows) {
            ElMessage.warning(`${field.label}至少需要 ${minRows} 行`);
            return false;
          }
          const maxRows = getEffectiveMaxRows(field);
          if (maxRows !== null && rows.length > maxRows) {
            ElMessage.warning(`${field.label}最多允许 ${maxRows} 行`);
            return false;
          }
          const rowError = validateDetailRows(field, rows);
          if (rowError) {
            ElMessage.warning(rowError);
            return false;
          }
          continue;
        }
        const error = validateWorkflowFieldValue(field, initiateForm.formData[field.key], '');
        if (error) {
          ElMessage.warning(error);
          return false;
        }
      }
      return true;
    }

    // 监听表单数据变化：先重算明细表，再防抖 300ms 刷新流程预览（避免行编辑放大刷新频率）
    let approvalPathDebounceTimer = null;
    watch(() => initiateForm.formData, () => {
      recomputeAllDetails();
      if (approvalPathDebounceTimer) {
        clearTimeout(approvalPathDebounceTimer);
      }
      approvalPathDebounceTimer = setTimeout(() => {
        if (selectedWorkflow.value && currentStep.value === 2) {
          loadApprovalPath();
        }
      }, 300);
    }, {
      deep: true
    });

    // 组件卸载时清理审批路径预览防抖 timer
    onBeforeUnmount(() => {
      if (approvalPathDebounceTimer) {
        clearTimeout(approvalPathDebounceTimer);
        approvalPathDebounceTimer = null;
      }
    });
    async function submitInitiate() {
      if (!initiateForm.title) {
        ElMessage.warning('请输入申请标题');
        return;
      }
      if (workflowFileUploading.value > 0) {
        ElMessage.warning('附件上传中，请稍后提交');
        return;
      }

      // 校验动态表单：必填 + 行数区间 + 行内规则集 + 正则/min/max/maxLength
      if (!validateWorkflowForm()) {
        return;
      }
      const pathLoaded = await loadApprovalPath(true);
      if (!pathLoaded) {
        return;
      }
      if (hasMissingRequiredParticipantSelections()) {
        validateParticipantSelections();
        return;
      }
      if (!validateParticipantSelections()) {
        return;
      }
      try {
        const submitData = {
          templateCode: selectedWorkflow.value.templateCode,
          title: initiateForm.title,
          priority: priorityValueToNum[initiateForm.priority] || 0,
          description: initiateForm.description,
          formData: buildSubmitFormData(),
          selectedApproverUserIds: participantSelections.approvers,
          selectedCcUserIds: participantSelections.cc
        };
        await startApproval(submitData);
        ElMessage.success('审批申请已提交');
        closeInitiateModal();
        // 刷新列表或跳转到"我发起"tab
        activeTab.value = 'initiated';
      } catch (error) {
        ElMessage.error(error.message || '提交失败');
      }
    }

    // 发起审批方法
    const getTypeBg = type => {
      const typeMap = {
        'proposal': 'status-badge is-info',
        'franchisee': 'status-badge is-purple',
        'product': 'status-badge is-success',
        'refund': 'status-badge is-warning',
        'wealth': 'status-badge is-cyan',
        'customer': 'status-badge is-indigo',
        'order': 'status-badge is-orange'
      };
      return typeMap[type] || 'status-badge is-neutral';
    };

    // 列表类型图标底色（与类型徽章同色系，用于行首图标方块）
    const typeIconStyles = {
      'proposal': 'bg-blue-50 text-blue-600',
      'franchisee': 'bg-purple-50 text-purple-600',
      'product': 'bg-green-50 text-green-600',
      'refund': 'bg-amber-50 text-amber-600',
      'wealth': 'bg-cyan-100 text-cyan-700',
      'customer': 'bg-indigo-50 text-indigo-600',
      'order': 'bg-orange-50 text-orange-600'
    };
    const getTypeIconClass = type => typeIconStyles[type] || 'bg-slate-100 text-slate-500';

    // 列表类型图标（heroicons outline 路径）
    const typeIconPaths = {
      'proposal': 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
      'franchisee': 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
      'product': 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
      'refund': 'M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z',
      'wealth': 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
      'customer': 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
      'order': 'M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z'
    };
    const getTypeIconPath = type => typeIconPaths[type] || typeIconPaths.proposal;

    // 申请人头像首字
    const getApplicantInitial = name => name ? name.charAt(0) : '?';

    // 未读抄送记录（标题加粗 + 红点）
    const isUnreadCc = approval => Boolean(approval.isCcRecord && approval.ccStatus !== 'READ');

    // 优先级样式映射
    const priorityTextMap = {
      'urgent': 'status-badge is-danger',
      'high': 'status-badge is-warning',
      'normal': 'status-badge is-neutral'
    };
    const getPriorityClass = priority => {
      return priorityTextMap[priority] || 'status-badge is-neutral';
    };
    const openRejectModal = approval => {
      selectedApproval.value = approval;
      rejectForm.reason = '';
      showRejectModal.value = true;
      showDetailModal.value = false;
      nextTick(() => rejectReasonInput.value?.focus());
    };

    // 通过审批
    const approveItem = async approval => {
      try {
        await approveTask({
          instanceId: approval.instanceId || approval.id,
          actionType: 'AGREE',
          remark: approvalForm.comment
        });
        ElMessage.success('审批通过');
        syncHandledApproval(approval.id);
        showDetailModal.value = false;
        // 刷新列表
        loadApprovalsByTab();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    };

    // 驳回审批
    const confirmReject = async () => {
      if (!rejectForm.reason.trim()) {
        ElMessage.warning('请输入驳回原因');
        return;
      }
      try {
        await approveTask({
          instanceId: selectedApproval.value.instanceId || selectedApproval.value.id,
          actionType: 'REJECT',
          remark: rejectForm.reason
        });
        ElMessage.success('已驳回');
        syncHandledApproval(selectedApproval.value.id);
        showRejectModal.value = false;
        showDetailModal.value = false;
        // 刷新列表
        loadApprovalsByTab();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "审批中心"), _createElementVNode("p", {
          class: "list-page-description"
        }, "处理各类审批申请，包括方案审批、加盟商审核、产品发布等")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, tab => {
          return _openBlock(), _createElementBlock("button", {
            key: tab.value,
            onClick: $event => activeTab.value = tab.value,
            class: _normalizeClass(['py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors relative', activeTab.value === tab.value ? 'border-primary-500 text-primary-600' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'])
          }, [_createTextVNode(_toDisplayString(tab.label) + " ", 1), tab.count ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(tab.count), 1)) : _createCommentVNode("", true)], 10, _hoisted_4);
        }), 128))])]), _createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: handleRefresh
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: openInitiateModal,
            class: "btn-primary"
          }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 发起审批 ", -1)]))])), [[_directive_permission, 'workflow:start']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            class: "btn-outline-primary",
            onClick: openStatsExportModal
          }, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 17v-6m4 6V7m4 10v-3m5 4H4"
          })], -1), _createTextVNode(" 统计导出 ", -1)]))])), [[_directive_permission, 'workflow:stats:export']]), activeTab.value === 'cc' && ccUnreadCount.value > 0 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn-outline-primary",
            disabled: markingAllCcRead.value,
            onClick: handleMarkAllCcRead
          }, [_cache[21] || (_cache[21] = _createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createTextVNode(" " + _toDisplayString(markingAllCcRead.value ? '标记中...' : '一键已读'), 1)], 8, _hoisted_6)) : _createCommentVNode("", true)]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: loading.value,
            onClick: handleSearch
          }, " 搜索 ", 8, _hoisted_7), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: loading.value,
            onClick: handleReset
          }, " 重置 ", 8, _hoisted_8)]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: selectedType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedType.value = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "方案审批",
              value: "proposal"
            }), _createVNode(_component_el_option, {
              label: "加盟商审核",
              value: "franchisee"
            }), _createVNode(_component_el_option, {
              label: "产品发布",
              value: "product"
            }), _createVNode(_component_el_option, {
              label: "退款审批",
              value: "refund"
            }), _createVNode(_component_el_option, {
              label: "财富资金审批",
              value: "wealth"
            }), _createVNode(_component_el_option, {
              label: "客户审批",
              value: "customer"
            }), _createVNode(_component_el_option, {
              label: "订单审批",
              value: "order"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: selectedPriority.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectedPriority.value = $event),
            placeholder: "请选择优先级",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部优先级",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "紧急",
              value: "urgent"
            }), _createVNode(_component_el_option, {
              label: "高",
              value: "high"
            }), _createVNode(_component_el_option, {
              label: "普通",
              value: "normal"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("table", _hoisted_11, [_createElementVNode("thead", _hoisted_12, [_createElementVNode("tr", null, [_cache[22] || (_cache[22] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "审批标题", -1)), _cache[23] || (_cache[23] = _createElementVNode("th", {
          class: "data-table-th is-center"
        }, "类型", -1)), _cache[24] || (_cache[24] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "申请人", -1)), _cache[25] || (_cache[25] = _createElementVNode("th", {
          class: "data-table-th is-center"
        }, "状态", -1)), _cache[26] || (_cache[26] = _createElementVNode("th", {
          class: "data-table-th is-center"
        }, "申请时间", -1)), _createElementVNode("th", _hoisted_13, _toDisplayString(activeTab.value === 'completed' ? '我的操作' : '当前节点'), 1), _cache[27] || (_cache[27] = _createElementVNode("th", {
          class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作", -1))])]), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "data-table-row"
          }, [...(_cache[28] || (_cache[28] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-3"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-9 w-9 rounded-lg"
          }), _createElementVNode("div", {
            class: "space-y-2"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-44"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-3 w-28"
          })])])], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-5 w-16 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-2"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-4 w-16"
          })])], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-5 w-14 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-24"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-20"
          })], -1), _createElementVNode("td", {
            class: "data-table-td data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "mx-auto flex justify-center gap-2"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          })])], -1)]))]);
        }), 64)) : approvals.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [_createElementVNode("td", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[29] || (_cache[29] = _createElementVNode("div", {
          class: "mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100"
        }, [_createElementVNode("svg", {
          class: "h-7 w-7 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        })])], -1)), _createElementVNode("p", _hoisted_17, _toDisplayString(emptyStateText.value), 1)])])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(approvals.value, approval => {
          return _openBlock(), _createElementBlock("tr", {
            key: approval.id,
            class: "data-table-row group cursor-pointer",
            onClick: $event => openDetailModal(approval)
          }, [_createElementVNode("td", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
            class: _normalizeClass(['flex h-9 w-9 shrink-0 items-center justify-center rounded-lg', getTypeIconClass(approval.type)])
          }, [(_openBlock(), _createElementBlock("svg", _hoisted_21, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: getTypeIconPath(approval.type)
          }, null, 8, _hoisted_22)]))], 2), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [isUnreadCc(approval) ? (_openBlock(), _createElementBlock("span", _hoisted_25)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass(["data-table-cell-title truncate transition-colors group-hover:text-primary-600", {
              'font-bold': isUnreadCc(approval)
            }]),
            title: approval.title
          }, _toDisplayString(approval.title), 11, _hoisted_26), _createElementVNode("span", {
            class: _normalizeClass(["shrink-0", approval.priorityClass || getPriorityClass(approval.priority)])
          }, _toDisplayString(approval.priorityText), 3)]), _createElementVNode("div", _hoisted_27, [approval.instanceNo ? (_openBlock(), _createElementBlock("span", _hoisted_28, "编号 " + _toDisplayString(approval.instanceNo), 1)) : _createCommentVNode("", true), approval.amount !== null && approval.amount !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_29, "金额 ¥" + _toDisplayString(formatAmount(approval.amount)), 1)) : _createCommentVNode("", true), approval.description ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: "truncate",
            title: approval.description
          }, _toDisplayString(approval.description), 9, _hoisted_30)) : _createCommentVNode("", true)])])])]), _createElementVNode("td", _hoisted_31, [_createElementVNode("span", {
            class: _normalizeClass(getTypeBg(approval.type))
          }, _toDisplayString(approval.typeText), 3)]), _createElementVNode("td", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [approval.applicantAvatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: approval.applicantAvatar,
            alt: approval.applicant || '申请人头像',
            class: "h-full w-full object-cover"
          }, null, 8, _hoisted_35)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(getApplicantInitial(approval.applicant)), 1)], 64))]), _createElementVNode("span", _hoisted_36, _toDisplayString(approval.applicant || '-'), 1)])]), _createElementVNode("td", _hoisted_37, [getApprovalStatusText(approval) ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["gap-1.5", getApprovalStatusClass(approval)])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["h-1.5 w-1.5 rounded-full", getApprovalStatusDotClass(approval)])
          }, null, 2), _createTextVNode(" " + _toDisplayString(getApprovalStatusText(approval)), 1)], 2)) : (_openBlock(), _createElementBlock("span", _hoisted_38, "-"))]), _createElementVNode("td", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$formatDateTime(approval.applyTime)), 1), activeTab.value === 'pending' ? (_openBlock(), _createElementBlock("div", _hoisted_41, "已等待 " + _toDisplayString(approval.waitTime), 1)) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_42, [activeTab.value === 'completed' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [approval.actionTypeDesc ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["status-badge", getActionTypeClass(approval.actionType)])
          }, _toDisplayString(approval.actionTypeDesc), 3)) : (_openBlock(), _createElementBlock("span", _hoisted_43, "-")), approval.completeTime ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.$formatDateTime(approval.completeTime)), 1)) : _createCommentVNode("", true)], 64)) : activeTab.value === 'cc' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [approval.taskNodeName || approval.currentNodeName ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(approval.taskNodeName || approval.currentNodeName), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_46, "-"))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [approval.taskNodeName || approval.currentNodeName ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(approval.taskNodeName || approval.currentNodeName), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_48, "-")), activeTab.value === 'initiated' && approval.currentApproverNames?.length ? (_openBlock(), _createElementBlock("div", _hoisted_49, "处理人：" + _toDisplayString(approval.currentApproverNames.join('、')), 1)) : _createCommentVNode("", true)], 64))]), _createElementVNode("td", _hoisted_50, [_createElementVNode("div", {
            class: "flex items-center justify-center gap-1",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [_createElementVNode("button", {
            onClick: $event => openDetailModal(approval),
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情"
          }, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_51), resolveApprovalInstanceStatus(approval) === 'APPROVED' && approval.exportable === true ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => handleExportApprovalDocx(approval),
            class: "table-action-button is-teal",
            disabled: !!exportingDocxInstanceId.value,
            title: "导出 Word",
            "aria-label": "导出 Word"
          }, [...(_cache[31] || (_cache[31] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          })], -1)]))], 8, _hoisted_52)) : _createCommentVNode("", true), activeTab.value === 'initiated' && resolveApprovalInstanceStatus(approval) === 'APPROVING' ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            disabled: cancellingInstanceId.value === approval.instanceId,
            onClick: $event => handleCancelApproval(approval),
            class: "table-action-button is-warning",
            title: "取消审批",
            "aria-label": "取消审批"
          }, [...(_cache[32] || (_cache[32] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_53)) : _createCommentVNode("", true), activeTab.value === 'pending' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => approveItem(approval),
            class: "table-action-button is-success",
            title: "通过",
            "aria-label": "通过"
          }, [...(_cache[33] || (_cache[33] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_54)), [[_directive_permission, 'workflow:approve']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openRejectModal(approval),
            class: "table-action-button is-danger",
            title: "驳回",
            "aria-label": "驳回"
          }, [...(_cache[34] || (_cache[34] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_55)), [[_directive_permission, 'workflow:approve']])], 64)) : _createCommentVNode("", true)])])], 8, _hoisted_18);
        }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)]), _createVNode(ApprovalDetailModal, {
          modelValue: showDetailModal.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showDetailModal.value = $event),
          "instance-id": selectedApproval.value?.instanceId || selectedApproval.value?.id,
          type: selectedApproval.value?.type,
          priority: selectedApproval.value?.priority,
          "show-actions": showApprovalActions.value,
          "show-comment-editor": showApprovalActions.value,
          title: "审批详情",
          onApprove: handleApprove,
          onReject: handleReject
        }, null, 8, ["modelValue", "instance-id", "type", "priority", "show-actions", "show-comment-editor"]), _createVNode(AppModal, {
          visible: showRejectModal.value,
          size: "md",
          scrollable: false,
          onClose: _cache[7] || (_cache[7] = $event => showRejectModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_56, [_cache[36] || (_cache[36] = _createElementVNode("h3", {
            id: "reject-modal-title",
            class: "text-lg font-semibold text-slate-900"
          }, "驳回申请", -1)), _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = $event => showRejectModal.value = false),
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            "aria-label": "关闭"
          }, [...(_cache[35] || (_cache[35] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_cache[37] || (_cache[37] = _createElementVNode("div", {
            class: "text-sm text-slate-500 mb-1"
          }, "申请标题", -1)), _createElementVNode("div", _hoisted_59, _toDisplayString(selectedApproval.value?.title), 1)]), _createElementVNode("div", _hoisted_60, [_cache[38] || (_cache[38] = _createElementVNode("label", {
            for: "reject-reason",
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("驳回原因 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("textarea", {
            id: "reject-reason",
            ref_key: "rejectReasonInput",
            ref: rejectReasonInput,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => rejectForm.reason = $event),
            rows: "4",
            class: "form-textarea",
            placeholder: "请输入驳回原因"
          }, null, 512), [[_vModelText, rejectForm.reason]])])]), _createElementVNode("div", _hoisted_61, [_createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = $event => showRejectModal.value = false),
            class: "btn-secondary"
          }, "取消"), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: confirmReject,
            class: "btn-danger-secondary"
          }, [...(_cache[39] || (_cache[39] = [_createTextVNode("确认驳回", -1)]))])), [[_directive_permission, 'workflow:approve']])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showStatsExportModal.value,
          size: "md",
          onClose: closeStatsExportModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
          }, [_cache[41] || (_cache[41] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "统计导出", -1)), _createElementVNode("button", {
            onClick: closeStatsExportModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            "aria-label": "关闭"
          }, [...(_cache[40] || (_cache[40] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", null, [_cache[42] || (_cache[42] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("流程模板 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: statsExportForm.templateCode,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => statsExportForm.templateCode = $event),
            placeholder: "请选择已配置统计导出的模板",
            class: "form-select w-full",
            loading: statsTemplatesLoading.value
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statsExportTemplates.value, tpl => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: tpl.templateCode,
                label: tpl.templateName,
                value: tpl.templateCode
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading"]), !statsTemplatesLoading.value && statsExportTemplates.value.length === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_63, " 暂无可统计的模板，请先在流程设计器中开启\"统计导出\" ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", null, [_cache[43] || (_cache[43] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("开始日期 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_date_picker, {
            modelValue: statsExportForm.startDate,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => statsExportForm.startDate = $event),
            type: "date",
            class: "form-date w-full",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择开始日期"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[44] || (_cache[44] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("结束日期 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_date_picker, {
            modelValue: statsExportForm.endDate,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => statsExportForm.endDate = $event),
            type: "date",
            class: "form-date w-full",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择结束日期"
          }, null, 8, ["modelValue"])])]), _cache[45] || (_cache[45] = _createElementVNode("p", {
            class: "text-xs text-amber-600"
          }, "提示：dept 维度仅覆盖部署日之后提交的数据；仅统计审批通过的单据，时间跨度最长 12 个月。", -1))]), _createElementVNode("div", _hoisted_65, [_createElementVNode("button", {
            onClick: closeStatsExportModal,
            class: "btn-secondary"
          }, "取消"), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: handleStatsExport,
            class: "btn-primary",
            disabled: statsExporting.value
          }, [_createTextVNode(_toDisplayString(statsExporting.value ? '导出中...' : '导出'), 1)], 8, _hoisted_66)), [[_directive_permission, 'workflow:stats:export']])])]),
          _: 1
        }, 8, ["visible"]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: showInitiateModal.value,
          size: "4xl",
          onClose: closeInitiateModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", null, [_cache[46] || (_cache[46] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "发起审批", -1)), _createElementVNode("p", _hoisted_68, _toDisplayString(currentStep.value === 1 ? '选择合适的流程模板' : selectedWorkflow.value?.templateName || '填写审批信息'), 1)]), _createElementVNode("button", {
            onClick: closeInitiateModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors"
          }, [...(_cache[47] || (_cache[47] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_69, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(wizardSteps, (step, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: step.value
            }, [_createElementVNode("div", _hoisted_70, [_createElementVNode("div", {
              class: _normalizeClass(['step-circle', currentStep.value > step.value ? 'is-done' : currentStep.value === step.value ? 'is-active' : 'is-pending'])
            }, [currentStep.value > step.value ? (_openBlock(), _createElementBlock("svg", _hoisted_71, [...(_cache[48] || (_cache[48] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2.5",
              d: "M5 13l4 4L19 7"
            }, null, -1)]))])) : (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(index + 1), 1))], 2), _createElementVNode("span", {
              class: _normalizeClass(['step-label', currentStep.value >= step.value ? 'is-active' : ''])
            }, _toDisplayString(step.label), 3)]), index < wizardSteps.length - 1 ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['step-line', currentStep.value > step.value ? 'is-done' : ''])
            }, null, 2)) : _createCommentVNode("", true)], 64);
          }), 64))]), _createElementVNode("div", _hoisted_73, [_createVNode(_Transition, {
            name: "step-fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [currentStep.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_cache[50] || (_cache[50] = _createElementVNode("svg", {
              class: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => workflowSearch.value = $event),
              type: "text",
              placeholder: "搜索流程名称...",
              class: "form-search-input form-control-sm pr-8"
            }, null, 512), [[_vModelText, workflowSearch.value]]), workflowSearch.value ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[12] || (_cache[12] = $event => workflowSearch.value = ''),
              class: "absolute right-3 top-1/2 -translate-y-1/2"
            }, [...(_cache[49] || (_cache[49] = [_createElementVNode("svg", {
              class: "w-4 h-4 text-slate-400 hover:text-slate-600",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("div", {
              class: _normalizeClass(['category-item', !selectedCategoryId.value ? 'is-active' : '']),
              onClick: _cache[13] || (_cache[13] = $event => selectedCategoryId.value = null)
            }, [_cache[51] || (_cache[51] = _createElementVNode("span", {
              class: "category-item-icon bg-slate-100"
            }, [_createElementVNode("svg", {
              class: "w-3.5 h-3.5 text-slate-500",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 6h16M4 10h16M4 14h16M4 18h16"
            })])], -1)), _cache[52] || (_cache[52] = _createElementVNode("span", null, "全部", -1)), _createElementVNode("span", _hoisted_78, "(" + _toDisplayString(filteredWorkflows.value.length) + ")", 1)], 2), _cache[54] || (_cache[54] = _createElementVNode("div", {
              class: "border-t border-slate-100 my-1 mx-1"
            }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workflowCategories.value, category => {
              return _openBlock(), _createElementBlock("div", {
                key: category.id,
                class: _normalizeClass(['category-item', selectedCategoryId.value === category.id ? 'is-active' : '']),
                onClick: $event => selectedCategoryId.value = category.id
              }, [_cache[53] || (_cache[53] = _createElementVNode("span", {
                class: "category-item-icon bg-slate-100"
              }, [_createElementVNode("svg", {
                class: "w-3.5 h-3.5 text-slate-500",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              })])], -1)), _createElementVNode("span", _hoisted_80, _toDisplayString(category.categoryName), 1), _createElementVNode("span", _hoisted_81, "(" + _toDisplayString(getCategoryWorkflowCount(category.id)) + ")", 1)], 10, _hoisted_79);
            }), 128))]), _createElementVNode("div", _hoisted_82, [filteredWorkflows.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_83, [...(_cache[55] || (_cache[55] = [_createElementVNode("div", {
              class: "empty-state-icon"
            }, [_createElementVNode("svg", {
              class: "w-8 h-8 text-slate-300",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            })])], -1), _createElementVNode("p", {
              class: "empty-state-title"
            }, "暂无流程", -1), _createElementVNode("p", {
              class: "empty-state-desc"
            }, "请尝试其他分类或搜索关键词", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredWorkflows.value, workflow => {
              return _openBlock(), _createElementBlock("div", {
                key: workflow.id,
                class: _normalizeClass(['workflow-card', selectedWorkflow.value?.id === workflow.id ? 'is-selected' : '']),
                onClick: $event => selectWorkflow(workflow)
              }, [_createElementVNode("div", {
                class: _normalizeClass(['workflow-card-icon', getTypeBg(workflow.categoryCode)])
              }, [...(_cache[56] || (_cache[56] = [_createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              })], -1)]))], 2), _createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_createElementVNode("span", _hoisted_87, _toDisplayString(workflow.templateName), 1), _createElementVNode("span", _hoisted_88, "v" + _toDisplayString(workflow.version), 1)]), _createElementVNode("p", _hoisted_89, _toDisplayString(workflow.description || '暂无描述'), 1), _createElementVNode("div", _hoisted_90, [_createElementVNode("span", null, _toDisplayString(workflow.nodeCount || 0) + " 个节点", 1), _cache[57] || (_cache[57] = _createElementVNode("span", {
                class: "w-1 h-1 rounded-full bg-slate-300"
              }, null, -1)), _createElementVNode("span", null, _toDisplayString(workflow.categoryName), 1)])]), _createElementVNode("div", _hoisted_91, [_createElementVNode("span", {
                class: _normalizeClass(['w-2 h-2 rounded-full', workflow.status === 1 ? 'bg-green-500' : 'bg-slate-300'])
              }, null, 2), _cache[58] || (_cache[58] = _createElementVNode("svg", {
                class: "workflow-card-arrow w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M9 5l7 7-7 7"
              })], -1))])], 10, _hoisted_84);
            }), 128))])])])) : (_openBlock(), _createElementBlock("div", _hoisted_92, [_createElementVNode("button", {
              onClick: goBack,
              class: "flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700 mb-4 transition-colors"
            }, [...(_cache[59] || (_cache[59] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M15 19l-7-7 7-7"
            })], -1), _createTextVNode(" 返回选择 ", -1)]))]), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", {
              class: _normalizeClass(['w-10 h-10 rounded-xl flex items-center justify-center', getTypeBg(selectedWorkflow.value?.categoryCode)])
            }, [...(_cache[60] || (_cache[60] = [_createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            })], -1)]))], 2), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_94, _toDisplayString(selectedWorkflow.value?.templateName), 1), _createElementVNode("span", _hoisted_95, "v" + _toDisplayString(selectedWorkflow.value?.version), 1), _createElementVNode("p", _hoisted_96, _toDisplayString(selectedWorkflow.value?.description || '暂无描述'), 1)])]), _createVNode(_component_el_form, {
              model: initiateForm,
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_97, [_cache[61] || (_cache[61] = _createElementVNode("div", {
                class: "form-section-header"
              }, [_createElementVNode("svg", {
                class: "form-section-icon",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              })]), _createElementVNode("span", {
                class: "form-section-title"
              }, "基本信息")], -1)), _createElementVNode("div", _hoisted_98, [_createVNode(_component_el_form_item, {
                label: "申请标题",
                required: "",
                class: "col-span-2"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: initiateForm.title,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => initiateForm.title = $event),
                  placeholder: "请输入申请标题",
                  maxlength: "100",
                  "show-word-limit": "",
                  class: "form-control-sm"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "优先级"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: initiateForm.priority,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => initiateForm.priority = $event),
                  class: "w-full form-select form-control-sm"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "普通",
                    value: "normal"
                  }), _createVNode(_component_el_option, {
                    label: "高",
                    value: "high"
                  }), _createVNode(_component_el_option, {
                    label: "紧急",
                    value: "urgent"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })])]), workflowFormFields.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_99, [_cache[63] || (_cache[63] = _createElementVNode("div", {
                class: "form-section-header"
              }, [_createElementVNode("svg", {
                class: "form-section-icon",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              })]), _createElementVNode("span", {
                class: "form-section-title"
              }, "申请内容")], -1)), _createElementVNode("div", _hoisted_100, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workflowFormFields.value, field => {
                return _openBlock(), _createBlock(_component_el_form_item, {
                  key: field.key,
                  class: _normalizeClass(['TEXTAREA', 'DETAIL'].includes(field.type) ? 'col-span-2' : '')
                }, {
                  label: _withCtx(() => [_createElementVNode("span", _hoisted_101, [_createElementVNode("span", null, _toDisplayString(field.label), 1), field.required ? (_openBlock(), _createElementBlock("span", _hoisted_102, "*")) : _createCommentVNode("", true)])]),
                  default: _withCtx(() => [['TEXT', 'EMAIL', 'PHONE', 'URL'].includes(field.type) ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: initiateForm.formData[field.key],
                    "onUpdate:modelValue": $event => initiateForm.formData[field.key] = $event,
                    placeholder: `请输入${field.label}`,
                    class: "w-full form-control-sm"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : ['NUMBER', 'MONEY'].includes(field.type) ? (_openBlock(), _createBlock(_component_el_input_number, {
                    key: 1,
                    modelValue: initiateForm.formData[field.key],
                    "onUpdate:modelValue": $event => initiateForm.formData[field.key] = $event,
                    min: getWorkflowNumberMin(field),
                    max: getWorkflowNumberMax(field),
                    precision: field.type === 'MONEY' ? 2 : 0,
                    class: "w-full form-number form-control-sm",
                    placeholder: `请输入`
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "precision"])) : field.type === 'TEXTAREA' ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 2,
                    modelValue: initiateForm.formData[field.key],
                    "onUpdate:modelValue": $event => initiateForm.formData[field.key] = $event,
                    type: "textarea",
                    rows: 2,
                    placeholder: `请输入${field.label}`,
                    maxlength: "500",
                    class: "w-full form-control-sm"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : field.type === 'DATE' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                    key: 3,
                    modelValue: initiateForm.formData[field.key],
                    "onUpdate:modelValue": $event => initiateForm.formData[field.key] = $event,
                    type: "date",
                    placeholder: `请选择${field.label}`,
                    class: "w-full form-date form-control-sm",
                    format: "YYYY年MM月DD日",
                    "value-format": "YYYY-MM-DD"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : field.type === 'DATETIME' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                    key: 4,
                    modelValue: initiateForm.formData[field.key],
                    "onUpdate:modelValue": $event => initiateForm.formData[field.key] = $event,
                    type: "datetime",
                    placeholder: `请选择${field.label}`,
                    class: "w-full form-date form-control-sm",
                    format: "YYYY年MM月DD日 HH:mm:ss",
                    "value-format": "YYYY-MM-DD HH:mm:ss"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : field.type === 'SELECT' ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 5,
                    modelValue: initiateForm.formData[field.key],
                    "onUpdate:modelValue": $event => initiateForm.formData[field.key] = $event,
                    placeholder: `请选择${field.label}`,
                    class: "w-full form-select form-control-sm",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, opt => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: opt.value,
                        label: opt.label,
                        value: opt.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])) : field.type === 'RADIO' ? (_openBlock(), _createBlock(_component_el_radio_group, {
                    key: 6,
                    modelValue: initiateForm.formData[field.key],
                    "onUpdate:modelValue": $event => initiateForm.formData[field.key] = $event,
                    class: "flex flex-wrap gap-3"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, opt => {
                      return _openBlock(), _createBlock(_component_el_radio, {
                        key: opt.value,
                        label: opt.value
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])) : field.type === 'CHECKBOX' ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                    key: 7,
                    modelValue: initiateForm.formData[field.key],
                    "onUpdate:modelValue": $event => initiateForm.formData[field.key] = $event,
                    class: "flex flex-wrap gap-3"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, opt => {
                      return _openBlock(), _createBlock(_component_el_checkbox, {
                        key: opt.value,
                        label: opt.value
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])) : field.type === 'SWITCH' ? (_openBlock(), _createBlock(_component_el_switch, {
                    key: 8,
                    modelValue: initiateForm.formData[field.key],
                    "onUpdate:modelValue": $event => initiateForm.formData[field.key] = $event
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])) : field.type === 'FILE' ? (_openBlock(), _createBlock(FileUpload, {
                    key: 9,
                    files: initiateForm.formData[field.key] || [],
                    accept: _unref(APPROVAL_ATTACHMENT_ACCEPT),
                    "max-count": field.maxCount || 5,
                    "max-size": field.maxSize || 10,
                    "onUpdate:files": $event => initiateForm.formData[field.key] = $event,
                    onUploadingChange: onWorkflowUploadingChange
                  }, null, 8, ["files", "accept", "max-count", "max-size", "onUpdate:files"])) : field.type === 'DETAIL' ? (_openBlock(), _createElementBlock("div", _hoisted_103, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(initiateForm.formData[field.key] || [], (row, rowIndex) => {
                    return _openBlock(), _createElementBlock("div", {
                      key: rowIndex,
                      class: "border border-slate-200 rounded-lg p-3 space-y-2 bg-white"
                    }, [_createElementVNode("div", _hoisted_104, [_createElementVNode("span", _hoisted_105, _toDisplayString(field.label) + " " + _toDisplayString(rowIndex + 1), 1), _createElementVNode("button", {
                      type: "button",
                      class: "table-action-button is-danger",
                      disabled: !canRemoveDetailRow(field),
                      title: canRemoveDetailRow(field) ? '删除此行' : '至少保留 ' + _unref(getEffectiveMinRows)(field) + ' 行',
                      onClick: $event => removeDetailRow(field, rowIndex)
                    }, "删除", 8, _hoisted_106)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.children || [], child => {
                      return _openBlock(), _createElementBlock("div", {
                        key: child.key
                      }, [_createElementVNode("label", _hoisted_107, [_createTextVNode(_toDisplayString(child.label), 1), child.required ? (_openBlock(), _createElementBlock("span", _hoisted_108, "*")) : _createCommentVNode("", true)]), child.computed ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        value: row[child.key] == null ? '-' : row[child.key],
                        class: "form-readonly form-control-sm w-full",
                        readonly: "",
                        tabindex: "-1"
                      }, null, 8, _hoisted_109)) : ['TEXT', 'EMAIL', 'PHONE', 'URL'].includes(child.type) ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        modelValue: row[child.key],
                        "onUpdate:modelValue": $event => row[child.key] = $event,
                        placeholder: child.placeholder || `请输入${child.label}`,
                        class: "w-full form-control-sm"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : ['NUMBER', 'MONEY'].includes(child.type) ? (_openBlock(), _createBlock(_component_el_input_number, {
                        key: 2,
                        modelValue: row[child.key],
                        "onUpdate:modelValue": $event => row[child.key] = $event,
                        min: getWorkflowNumberMin(child),
                        max: getWorkflowNumberMax(child),
                        precision: child.type === 'MONEY' ? 2 : 0,
                        placeholder: child.placeholder || `请输入${child.label}`,
                        class: "w-full form-number form-control-sm",
                        "controls-position": "right"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "precision", "placeholder"])) : child.type === 'TEXTAREA' ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 3,
                        modelValue: row[child.key],
                        "onUpdate:modelValue": $event => row[child.key] = $event,
                        type: "textarea",
                        rows: 2,
                        placeholder: child.placeholder || `请输入${child.label}`,
                        class: "w-full form-control-sm"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : child.type === 'DATE' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 4,
                        modelValue: row[child.key],
                        "onUpdate:modelValue": $event => row[child.key] = $event,
                        type: "date",
                        placeholder: child.placeholder || '请选择',
                        class: "w-full form-date form-control-sm",
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : child.type === 'DATETIME' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 5,
                        modelValue: row[child.key],
                        "onUpdate:modelValue": $event => row[child.key] = $event,
                        type: "datetime",
                        placeholder: child.placeholder || '请选择',
                        class: "w-full form-date form-control-sm",
                        "value-format": "YYYY-MM-DD HH:mm:ss"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : child.type === 'SELECT' ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 6,
                        modelValue: row[child.key],
                        "onUpdate:modelValue": $event => row[child.key] = $event,
                        placeholder: child.placeholder || '请选择',
                        class: "w-full form-select form-control-sm",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.options, opt => {
                          return _openBlock(), _createBlock(_component_el_option, {
                            key: opt.value,
                            label: opt.label,
                            value: opt.value
                          }, null, 8, ["label", "value"]);
                        }), 128))]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])) : child.type === 'RADIO' ? (_openBlock(), _createBlock(_component_el_radio_group, {
                        key: 7,
                        modelValue: row[child.key],
                        "onUpdate:modelValue": $event => row[child.key] = $event,
                        class: "flex flex-wrap gap-3"
                      }, {
                        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.options, opt => {
                          return _openBlock(), _createBlock(_component_el_radio, {
                            key: opt.value,
                            label: opt.value
                          }, {
                            default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                            _: 2
                          }, 1032, ["label"]);
                        }), 128))]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])) : child.type === 'CHECKBOX' ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                        key: 8,
                        modelValue: row[child.key],
                        "onUpdate:modelValue": $event => row[child.key] = $event,
                        class: "flex flex-wrap gap-3"
                      }, {
                        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.options, opt => {
                          return _openBlock(), _createBlock(_component_el_checkbox, {
                            key: opt.value,
                            label: opt.value
                          }, {
                            default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                            _: 2
                          }, 1032, ["label"]);
                        }), 128))]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])) : child.type === 'FILE' ? (_openBlock(), _createBlock(FileUpload, {
                        key: 9,
                        files: row[child.key] || [],
                        accept: child.accept || _unref(APPROVAL_ATTACHMENT_ACCEPT),
                        "max-count": child.maxCount || 5,
                        "max-size": child.maxSize || 10,
                        "onUpdate:files": $event => row[child.key] = $event,
                        onUploadingChange: onWorkflowUploadingChange
                      }, null, 8, ["files", "accept", "max-count", "max-size", "onUpdate:files"])) : _createCommentVNode("", true)]);
                    }), 128))]);
                  }), 128)), _createElementVNode("div", _hoisted_110, [canAddDetailRow(field) ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    link: "",
                    size: "small",
                    onClick: $event => addDetailRow(field)
                  }, {
                    default: _withCtx(() => [...(_cache[62] || (_cache[62] = [_createTextVNode("+ 添加一行", -1)]))]),
                    _: 1
                  }, 8, ["onClick"])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_111, " 共 " + _toDisplayString((initiateForm.formData[field.key] || []).length) + " 行" + _toDisplayString(_unref(getEffectiveMaxRows)(field) !== null ? `，最多 ${_unref(getEffectiveMaxRows)(field)} 行` : '，不限'), 1)]), (field.summary || []).length ? (_openBlock(), _createElementBlock("div", _hoisted_112, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.children || [], child => {
                    return _openBlock(), _createElementBlock(_Fragment, {
                      key: child.key
                    }, [getDetailSummary(field, child.key) ? (_openBlock(), _createElementBlock("div", _hoisted_113, [_createElementVNode("span", _hoisted_114, _toDisplayString(child.label) + "合计：", 1), _createElementVNode("span", _hoisted_115, _toDisplayString(child.type === 'MONEY' ? '¥' : '') + _toDisplayString(formatDetailNumber(initiateForm.formData[getDetailSummary(field, child.key).targetKey], child.type === 'MONEY' ? 2 : undefined)), 1)])) : _createCommentVNode("", true)], 64);
                  }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
                  _: 2
                }, 1032, ["class"]);
              }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_116, [_cache[64] || (_cache[64] = _createElementVNode("div", {
                class: "form-section-header"
              }, [_createElementVNode("svg", {
                class: "form-section-icon",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 6h16M4 12h16M4 18h7"
              })]), _createElementVNode("span", {
                class: "form-section-title"
              }, "申请说明")], -1)), _createVNode(_component_el_input, {
                modelValue: initiateForm.description,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => initiateForm.description = $event),
                type: "textarea",
                rows: 3,
                placeholder: "请详细描述申请内容...",
                maxlength: "500",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_117, [_createElementVNode("div", _hoisted_118, [_cache[65] || (_cache[65] = _createElementVNode("svg", {
                class: "form-section-icon",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              })], -1)), _cache[66] || (_cache[66] = _createElementVNode("span", {
                class: "form-section-title"
              }, "审批流程", -1)), _createElementVNode("span", _hoisted_119, "(" + _toDisplayString(displayedApprovalPath.value?.displayedNodes?.length || 0) + " 个节点)", 1)]), _createElementVNode("div", _hoisted_120, [approvalPathLoading.value && !approvalPathData.value ? (_openBlock(), _createElementBlock("div", _hoisted_121, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, n => {
                return _createElementVNode("div", {
                  key: n,
                  class: "flex items-center gap-3 p-3 bg-slate-50 rounded-xl animate-pulse"
                }, [...(_cache[67] || (_cache[67] = [_createElementVNode("div", {
                  class: "w-8 h-8 rounded-full bg-slate-200"
                }, null, -1), _createElementVNode("div", {
                  class: "flex-1"
                }, [_createElementVNode("div", {
                  class: "h-3 w-24 bg-slate-200 rounded mb-1.5"
                }), _createElementVNode("div", {
                  class: "h-2 w-32 bg-slate-200 rounded"
                })], -1)]))]);
              }), 64))])) : displayedApprovalPath.value?.displayedNodes?.length ? (_openBlock(), _createElementBlock("div", _hoisted_122, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedApprovalPath.value.displayedNodes, (node, index) => {
                return _openBlock(), _createElementBlock(_Fragment, {
                  key: node.nodeId
                }, [_createElementVNode("div", _hoisted_123, [_createElementVNode("div", {
                  class: _normalizeClass(['approval-node-number', node.nodeType === 'CC' ? 'is-cc' : 'is-approval'])
                }, _toDisplayString(index + 1), 3), _createElementVNode("div", _hoisted_124, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_125, _toDisplayString(node.nodeName), 1), _createElementVNode("span", {
                  class: _normalizeClass(['approval-node-tag', node.nodeType === 'CC' ? 'is-cc' : 'is-approval'])
                }, _toDisplayString(node.nodeType === 'CC' ? '抄送' : '审批'), 3), getApprovalModeBadgeText(node) ? (_openBlock(), _createElementBlock("span", _hoisted_126, _toDisplayString(getApprovalModeBadgeText(node)), 1)) : _createCommentVNode("", true)]), node.approvers?.length ? (_openBlock(), _createElementBlock("div", _hoisted_127, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(node.approvers.slice(0, 3), (approver, idx) => {
                  return _openBlock(), _createElementBlock("div", {
                    key: approver.userId || idx,
                    class: "approval-node-approver-item"
                  }, [_createElementVNode("div", _hoisted_128, [approver.avatar ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: approver.avatar,
                    alt: ""
                  }, null, 8, _hoisted_129)) : (_openBlock(), _createElementBlock("span", _hoisted_130, _toDisplayString(approver.userName?.charAt(0) || 'U'), 1))]), _createElementVNode("span", _hoisted_131, _toDisplayString(approver.userName), 1)]);
                }), 128)), node.approvers.length > 3 ? (_openBlock(), _createElementBlock("span", _hoisted_132, " +" + _toDisplayString(node.approvers.length - 3) + " 人 ", 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_133, [...(_cache[68] || (_cache[68] = [_createElementVNode("svg", {
                  class: "w-3.5 h-3.5",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [_createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                })], -1), _createTextVNode(" 待指定 ", -1)]))])), node.requiresSelection ? (_openBlock(), _createElementBlock("div", _hoisted_134, [_createVNode(UserSelector, {
                  "model-value": selectedUsersForNode(node),
                  "max-select": node.maxSelect || null,
                  "exclude-ids": approverExcludeIdsForNode(node),
                  "hide-add-button": !!node.maxSelect && selectedUsersForNode(node).length >= node.maxSelect,
                  multiple: "",
                  placeholder: node.selectionType === 'CC' ? '请选择抄送人' : '请选择审批人',
                  "onUpdate:modelValue": val => setSelectedUsersForNode(node, val)
                }, null, 8, ["model-value", "max-select", "exclude-ids", "hide-add-button", "placeholder", "onUpdate:modelValue"]), _createElementVNode("div", _hoisted_135, [node.selectionRequired ? (_openBlock(), _createElementBlock("span", _hoisted_136, "必选")) : (_openBlock(), _createElementBlock("span", _hoisted_137, "可选")), node.selectionRequired && node.minSelect ? (_openBlock(), _createElementBlock("span", _hoisted_138, "，至少 " + _toDisplayString(node.minSelect) + " 人", 1)) : _createCommentVNode("", true), node.maxSelect ? (_openBlock(), _createElementBlock("span", _hoisted_139, "，最多 " + _toDisplayString(node.maxSelect) + " 人", 1)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])]), index < displayedApprovalPath.value.displayedNodes.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_140, [...(_cache[69] || (_cache[69] = [_createElementVNode("svg", {
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [_createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 9l-7 7-7-7"
                })], -1)]))])) : _createCommentVNode("", true)], 64);
              }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_141, " 暂无法加载审批路径 "))])])]),
              _: 1
            }, 8, ["model"])]))]),
            _: 1
          })]), _createElementVNode("div", _hoisted_142, [_createElementVNode("div", null, [currentStep.value === 2 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: goBack,
            class: "btn-secondary"
          }, [...(_cache[70] || (_cache[70] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 19l-7-7 7-7"
          })], -1), _createTextVNode(" 上一步 ", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_143, [_createElementVNode("button", {
            onClick: closeInitiateModal,
            class: "btn-secondary"
          }, "取消"), currentStep.value === 1 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[17] || (_cache[17] = $event => selectedWorkflow.value ? currentStep.value = 2 : null),
            disabled: !selectedWorkflow.value,
            class: "btn-primary"
          }, [...(_cache[71] || (_cache[71] = [_createTextVNode(" 下一步：填写信息 ", -1), _createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5l7 7-7 7"
          })], -1)]))], 8, _hoisted_144)), [[_directive_permission, 'workflow:start']]) : _createCommentVNode("", true), currentStep.value === 2 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: submitInitiate,
            disabled: !canSubmitInitiate.value,
            class: "btn-primary"
          }, [...(_cache[72] || (_cache[72] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1), _createTextVNode(" 提交审批 ", -1)]))], 8, _hoisted_145)), [[_directive_permission, 'workflow:start']]) : _createCommentVNode("", true)])])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};